// Generated from ./util_cohort_builder_grammar/stable/IndexDate.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { IndexDateListener } from "./IndexDateListener.js";
import { IndexDateVisitor } from "./IndexDateVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class IndexDate extends antlr.Parser {
    public static readonly INDEX_DATE = 1;
    public static readonly EVENT = 2;
    public static readonly CALENDAR_DATE = 3;
    public static readonly UPPER_DATE_BOUND = 4;
    public static readonly LOWER_DATE_BOUND = 5;
    public static readonly DERIVED_EVENT_DATE = 6;
    public static readonly CONSTRAINTS = 7;
    public static readonly ANY_ORDER = 8;
    public static readonly IS_EVENT_DATE = 9;
    public static readonly TC = 10;
    public static readonly TEMPORAL_CONSTRAINT_ABBR = 11;
    public static readonly TEMPORAL_CONSTRAINT = 12;
    public static readonly POSITION = 13;
    public static readonly CF = 14;
    public static readonly CONCEPT_FILTER = 15;
    public static readonly CONCEPT_FILTER_ABBR = 16;
    public static readonly NF = 17;
    public static readonly NUMERIC_FILTER = 18;
    public static readonly NUMERIC_FILTER_ABBR = 19;
    public static readonly SF = 20;
    public static readonly STRING_FILTER = 21;
    public static readonly STRING_FILTER_ABBR = 22;
    public static readonly UF = 23;
    public static readonly UNIQUENESS_FILTER = 24;
    public static readonly UNIQUENESS_FILTER_ABBR = 25;
    public static readonly RF = 26;
    public static readonly RELATED_ENTITY_FILTER = 27;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 28;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 29;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 30;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 31;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 32;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 33;
    public static readonly QUALIFIED_PERSON_ALIAS = 34;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 35;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 36;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 37;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 38;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 39;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 40;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 41;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 42;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 43;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 44;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 45;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 46;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 47;
    public static readonly CONCEPT_GROUP = 48;
    public static readonly CARE_SITE_ALIAS = 49;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 50;
    public static readonly DRUG_EXPOSURE_ALIAS = 51;
    public static readonly MEASUREMENT_ALIAS = 52;
    public static readonly OBSERVATION_ALIAS = 53;
    public static readonly PERSON_ALIAS = 54;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 55;
    public static readonly PROVIDER_ALIAS = 56;
    public static readonly VISIT_OCCURRENCE_ALIAS = 57;
    public static readonly MERGED_EVENT_NAME = 58;
    public static readonly SEQUENCE_EVENT_NAME = 59;
    public static readonly INSTANCE_EVENT_NAME = 60;
    public static readonly SUBJECTS_VARIABLE_NAME = 61;
    public static readonly NAMESPACE_QUALIFIER = 62;
    public static readonly SUBJECTS_VARIABLE = 63;
    public static readonly CONCEPT = 64;
    public static readonly QUALIFIED_MERGED_EVENT = 65;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 66;
    public static readonly QUALIFIED_INSTANCE_EVENT = 67;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 68;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 69;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 70;
    public static readonly MERGED_EVENT = 71;
    public static readonly SEQUENCE_EVENT = 72;
    public static readonly INSTANCE_EVENT = 73;
    public static readonly DERIVED_EVENT = 74;
    public static readonly LINE_COMMENT = 75;
    public static readonly INT = 76;
    public static readonly M = 77;
    public static readonly D = 78;
    public static readonly Y = 79;
    public static readonly DATE = 80;
    public static readonly OPEN_PAREN = 81;
    public static readonly CLOSE_PAREN = 82;
    public static readonly SEMICOLON = 83;
    public static readonly COMMA = 84;
    public static readonly EQ = 85;
    public static readonly MULTIPLY = 86;
    public static readonly DIVIDE = 87;
    public static readonly ADD = 88;
    public static readonly SUBTRACT = 89;
    public static readonly CONTAINS = 90;
    public static readonly NEQ = 91;
    public static readonly LTE = 92;
    public static readonly GTE = 93;
    public static readonly LT = 94;
    public static readonly GT = 95;
    public static readonly MAX = 96;
    public static readonly MIN = 97;
    public static readonly AVG = 98;
    public static readonly COUNT = 99;
    public static readonly LEAST = 100;
    public static readonly GREATEST = 101;
    public static readonly IN = 102;
    public static readonly AND = 103;
    public static readonly OR = 104;
    public static readonly NOT = 105;
    public static readonly COMPLEMENT = 106;
    public static readonly UNION = 107;
    public static readonly INTERSECTION = 108;
    public static readonly DIFFERENCE = 109;
    public static readonly INDEX = 110;
    public static readonly TIME_UNIT = 111;
    public static readonly DAYS = 112;
    public static readonly WEEKS = 113;
    public static readonly MONTHS = 114;
    public static readonly YEARS = 115;
    public static readonly MINIMUM_BETWEEN = 116;
    public static readonly MAXIMUM_BETWEEN = 117;
    public static readonly TOTAL_BETWEEN = 118;
    public static readonly FIXED_WINDOW = 119;
    public static readonly ROLLING_WINDOW = 120;
    public static readonly PERIOD = 121;
    public static readonly WS = 122;
    public static readonly CARE_SITE = 123;
    public static readonly CONDITION_OCCURRENCE = 124;
    public static readonly DRUG_EXPOSURE = 125;
    public static readonly MEASUREMENT = 126;
    public static readonly OBSERVATION = 127;
    public static readonly PERSON = 128;
    public static readonly PROCEDURE_OCCURRENCE = 129;
    public static readonly PROVIDER = 130;
    public static readonly VISIT_OCCURRENCE = 131;
    public static readonly QUALIFIED_CARE_SITE = 132;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 133;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 134;
    public static readonly QUALIFIED_MEASUREMENT = 135;
    public static readonly QUALIFIED_OBSERVATION = 136;
    public static readonly QUALIFIED_PERSON = 137;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 138;
    public static readonly QUALIFIED_PROVIDER = 139;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 140;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 141;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 142;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 143;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 144;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 145;
    public static readonly SUBJECT_VARIABLE_PERSON = 146;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 147;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 148;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 149;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 150;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 151;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 152;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 153;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 154;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 155;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 156;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 157;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 158;
    public static readonly PERSON_INT_ATTRIBUTE = 159;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 160;
    public static readonly QUANTITY = 161;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 162;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 163;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 164;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 165;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 166;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 167;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 168;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 169;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 170;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 171;
    public static readonly COMMON_STRING_ATTRIBUTE = 172;
    public static readonly GENDER_SOURCE_VALUE = 173;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 174;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 175;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 176;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 177;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 178;
    public static readonly PERSON_STRING_ATTRIBUTE = 179;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 180;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 181;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 182;
    public static readonly RULE_index_date = 0;
    public static readonly RULE_index_date_definition = 1;
    public static readonly RULE_calendar_date = 2;
    public static readonly RULE_index_event_date = 3;
    public static readonly RULE_index_date_bounds = 4;
    public static readonly RULE_upper_date_bounds = 5;
    public static readonly RULE_lower_date_bounds = 6;
    public static readonly RULE_calendarError = 7;
    public static readonly RULE_index_event_date_error = 8;
    public static readonly RULE_lower_date_bounds_error = 9;
    public static readonly RULE_upper_date_bounds_error = 10;
    public static readonly RULE_derived_event = 11;
    public static readonly RULE_merged_event = 12;
    public static readonly RULE_merged_event_criteria = 13;
    public static readonly RULE_merged_event_criterion = 14;
    public static readonly RULE_merged_event_filter_criterion = 15;
    public static readonly RULE_merged_event_event = 16;
    public static readonly RULE_merged_event_filter = 17;
    public static readonly RULE_merged_event_uniqueness_filter = 18;
    public static readonly RULE_merged_event_uniqueness_filter_criteria = 19;
    public static readonly RULE_merged_event_filter_error = 20;
    public static readonly RULE_sequence_event = 21;
    public static readonly RULE_sequence_event_criteria = 22;
    public static readonly RULE_sequence_event_criterion = 23;
    public static readonly RULE_sequence_event_constraint = 24;
    public static readonly RULE_temporal_constraint = 25;
    public static readonly RULE_sequence_temporal_filter = 26;
    public static readonly RULE_sequence_event_event = 27;
    public static readonly RULE_selected_sequence_event = 28;
    public static readonly RULE_unselected_sequence_event = 29;
    public static readonly RULE_instance_event = 30;
    public static readonly RULE_instance_event_criteria = 31;
    public static readonly RULE_instance_event_criterion = 32;
    public static readonly RULE_instance_event_event = 33;
    public static readonly RULE_instance_event_position = 34;
    public static readonly RULE_aggregation_qualified = 35;
    public static readonly RULE_specific_instance = 36;
    public static readonly RULE_instance_event_position_error = 37;
    public static readonly RULE_qualified_simple_event = 38;
    public static readonly RULE_qualified_derived_event = 39;
    public static readonly RULE_sequence_event_constraint_error = 40;
    public static readonly RULE_derived_event_error = 41;
    public static readonly RULE_derived_uniqueness_filter = 42;
    public static readonly RULE_derived_uniqueness_filter_window = 43;
    public static readonly RULE_derived_fixed_window_uniqueness_filter = 44;
    public static readonly RULE_derived_rolling_window_uniqueness_filter = 45;
    public static readonly RULE_derived_event_int = 46;
    public static readonly RULE_simple_event = 47;
    public static readonly RULE_condition_occurrence_event = 48;
    public static readonly RULE_drug_exposure_event = 49;
    public static readonly RULE_measurement_event = 50;
    public static readonly RULE_observation_event = 51;
    public static readonly RULE_procedure_occurrence_event = 52;
    public static readonly RULE_visit_occurrence_event = 53;
    public static readonly RULE_condition_occurrence_event_definition = 54;
    public static readonly RULE_drug_exposure_event_definition = 55;
    public static readonly RULE_measurement_event_definition = 56;
    public static readonly RULE_observation_event_definition = 57;
    public static readonly RULE_procedure_occurrence_event_definition = 58;
    public static readonly RULE_visit_occurrence_event_definition = 59;
    public static readonly RULE_condition_occurrence_event_criteria = 60;
    public static readonly RULE_condition_occurrence_event_filter = 61;
    public static readonly RULE_condition_occurrence_concept_filters = 62;
    public static readonly RULE_condition_occurrence_concept_group_filter = 63;
    public static readonly RULE_condition_occurrence_concept_filter = 64;
    public static readonly RULE_condition_occurrence_uniqueness_filters = 65;
    public static readonly RULE_condition_occurrence_uniqueness_filter = 66;
    public static readonly RULE_condition_occurrence_related_entity_filters = 67;
    public static readonly RULE_condition_occurrence_related_entity_filter = 68;
    public static readonly RULE_condition_occurrence_sub_filter = 69;
    public static readonly RULE_condition_occurrence_error_sub_filter = 70;
    public static readonly RULE_condition_occurrence_error_filter = 71;
    public static readonly RULE_drug_exposure_event_criteria = 72;
    public static readonly RULE_drug_exposure_event_filter = 73;
    public static readonly RULE_drug_exposure_concept_filters = 74;
    public static readonly RULE_drug_exposure_concept_group_filter = 75;
    public static readonly RULE_drug_exposure_concept_filter = 76;
    public static readonly RULE_drug_exposure_numeric_filters = 77;
    public static readonly RULE_drug_exposure_float_filter = 78;
    public static readonly RULE_drug_exposure_int_filter = 79;
    public static readonly RULE_drug_exposure_uniqueness_filters = 80;
    public static readonly RULE_drug_exposure_uniqueness_filter = 81;
    public static readonly RULE_drug_exposure_related_entity_filters = 82;
    public static readonly RULE_drug_exposure_related_entity_filter = 83;
    public static readonly RULE_drug_exposure_error_filter = 84;
    public static readonly RULE_measurement_event_criteria = 85;
    public static readonly RULE_measurement_event_filter = 86;
    public static readonly RULE_measurement_concept_filters = 87;
    public static readonly RULE_measurement_concept_group_filter = 88;
    public static readonly RULE_measurement_concept_filter = 89;
    public static readonly RULE_measurement_numeric_filters = 90;
    public static readonly RULE_measurement_float_filter = 91;
    public static readonly RULE_measurement_uniqueness_filters = 92;
    public static readonly RULE_measurement_uniqueness_filter = 93;
    public static readonly RULE_measurement_related_entity_filters = 94;
    public static readonly RULE_measurement_related_entity_filter = 95;
    public static readonly RULE_measurement_error_filter = 96;
    public static readonly RULE_observation_event_criteria = 97;
    public static readonly RULE_observation_event_filter = 98;
    public static readonly RULE_observation_concept_filters = 99;
    public static readonly RULE_observation_concept_group_filter = 100;
    public static readonly RULE_observation_concept_filter = 101;
    public static readonly RULE_observation_numeric_filters = 102;
    public static readonly RULE_observation_float_filter = 103;
    public static readonly RULE_observation_uniqueness_filters = 104;
    public static readonly RULE_observation_uniqueness_filter = 105;
    public static readonly RULE_observation_related_entity_filters = 106;
    public static readonly RULE_observation_related_entity_filter = 107;
    public static readonly RULE_observation_error_filter = 108;
    public static readonly RULE_procedure_occurrence_event_criteria = 109;
    public static readonly RULE_procedure_occurrence_event_filter = 110;
    public static readonly RULE_procedure_occurrence_concept_filters = 111;
    public static readonly RULE_procedure_occurrence_concept_group_filter = 112;
    public static readonly RULE_procedure_occurrence_concept_filter = 113;
    public static readonly RULE_procedure_occurrence_numeric_filters = 114;
    public static readonly RULE_procedure_occurrence_int_filter = 115;
    public static readonly RULE_procedure_occurrence_uniqueness_filters = 116;
    public static readonly RULE_procedure_occurrence_uniqueness_filter = 117;
    public static readonly RULE_procedure_occurrence_related_entity_filters = 118;
    public static readonly RULE_procedure_occurrence_related_entity_filter = 119;
    public static readonly RULE_procedure_occurrence_error_filter = 120;
    public static readonly RULE_provider_concept_filters = 121;
    public static readonly RULE_provider_concept_group_filter = 122;
    public static readonly RULE_provider_concept_filter = 123;
    public static readonly RULE_provider_sub_filter = 124;
    public static readonly RULE_provider_error_sub_filter = 125;
    public static readonly RULE_visit_occurrence_event_criteria = 126;
    public static readonly RULE_visit_occurrence_event_filter = 127;
    public static readonly RULE_visit_occurrence_concept_filters = 128;
    public static readonly RULE_visit_occurrence_concept_group_filter = 129;
    public static readonly RULE_visit_occurrence_concept_filter = 130;
    public static readonly RULE_visit_occurrence_uniqueness_filters = 131;
    public static readonly RULE_visit_occurrence_uniqueness_filter = 132;
    public static readonly RULE_visit_occurrence_related_entity_filters = 133;
    public static readonly RULE_visit_occurrence_related_entity_filter = 134;
    public static readonly RULE_visit_occurrence_sub_filter = 135;
    public static readonly RULE_visit_occurrence_error_sub_filter = 136;
    public static readonly RULE_visit_occurrence_error_filter = 137;
    public static readonly RULE_comparison_op = 138;
    public static readonly RULE_simple_uniqueness_filter = 139;
    public static readonly RULE_simple_uniqueness_filter_window = 140;
    public static readonly RULE_fixed_window_uniqueness_filter = 141;
    public static readonly RULE_rolling_window_uniqueness_filter = 142;
    public static readonly RULE_simple_event_float = 143;
    public static readonly RULE_simple_event_int = 144;
    public static readonly RULE_concept_group_selection = 145;

    public static readonly literalNames = [
        null, "'INDEX_DATE'", "'EVENT'", "'CALENDAR_DATE'", "'UPPER_DATE_BOUND'", 
        "'LOWER_DATE_BOUND'", "'derived_event_date'", "'CONSTRAINTS'", "'ANY_ORDER'", 
        "'IS_EVENT_DATE'", null, "'TC'", "'TEMPORAL_CONSTRAINT'", "'POSITION'", 
        null, "'CONCEPT_FILTER'", "'CF'", null, "'NUMERIC_FILTER'", "'NF'", 
        null, "'STRING_FILTER'", "'SF'", null, "'UNIQUENESS_FILTER'", "'UF'", 
        null, "'RELATED_ENTITY_FILTER'", "'RF'", null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, "'::'", "'SUBJECTS_VARIABLE'", 
        null, "'QUALIFIED_MERGED_EVENT'", "'QUALIFIED_SEQUENCE_EVENT'", 
        "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "INDEX_DATE", "EVENT", "CALENDAR_DATE", "UPPER_DATE_BOUND", 
        "LOWER_DATE_BOUND", "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", 
        "IS_EVENT_DATE", "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", 
        "POSITION", "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", 
        "NUMERIC_FILTER", "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", 
        "STRING_FILTER_ABBR", "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", 
        "RF", "RELATED_ENTITY_FILTER", "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", 
        "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", "QUALIFIED_DRUG_EXPOSURE_ALIAS", 
        "QUALIFIED_MEASUREMENT_ALIAS", "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", 
        "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", "QUALIFIED_PROVIDER_ALIAS", 
        "QUALIFIED_VISIT_OCCURRENCE_ALIAS", "QUALIFIED_DERIVED_EVENT_NAME", 
        "SUBJECT_VARIABLE_CARE_SITE_ALIAS", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", 
        "SUBJECT_VARIABLE_OBSERVATION_ALIAS", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_PROVIDER_ALIAS", "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", "CONCEPT_GROUP", "CARE_SITE_ALIAS", 
        "CONDITION_OCCURRENCE_ALIAS", "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", 
        "OBSERVATION_ALIAS", "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", 
        "PROVIDER_ALIAS", "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", 
        "SEQUENCE_EVENT_NAME", "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", 
        "NAMESPACE_QUALIFIER", "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", 
        "QUALIFIED_SEQUENCE_EVENT", "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", 
        "SUBJECT_VARIABLE_SEQUENCE_EVENT", "SUBJECT_VARIABLE_INSTANCE_EVENT", 
        "MERGED_EVENT", "SEQUENCE_EVENT", "INSTANCE_EVENT", "DERIVED_EVENT", 
        "LINE_COMMENT", "INT", "M", "D", "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", 
        "SEMICOLON", "COMMA", "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", 
        "CONTAINS", "NEQ", "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", 
        "COUNT", "LEAST", "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", 
        "UNION", "INTERSECTION", "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", 
        "WEEKS", "MONTHS", "YEARS", "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", 
        "TOTAL_BETWEEN", "FIXED_WINDOW", "ROLLING_WINDOW", "PERIOD", "WS", 
        "CARE_SITE", "CONDITION_OCCURRENCE", "DRUG_EXPOSURE", "MEASUREMENT", 
        "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", "PROVIDER", "VISIT_OCCURRENCE", 
        "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", "QUALIFIED_DRUG_EXPOSURE", 
        "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", "QUALIFIED_PERSON", 
        "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", "QUALIFIED_VISIT_OCCURRENCE", 
        "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];
    public static readonly ruleNames = [
        "index_date", "index_date_definition", "calendar_date", "index_event_date", 
        "index_date_bounds", "upper_date_bounds", "lower_date_bounds", "calendarError", 
        "index_event_date_error", "lower_date_bounds_error", "upper_date_bounds_error", 
        "derived_event", "merged_event", "merged_event_criteria", "merged_event_criterion", 
        "merged_event_filter_criterion", "merged_event_event", "merged_event_filter", 
        "merged_event_uniqueness_filter", "merged_event_uniqueness_filter_criteria", 
        "merged_event_filter_error", "sequence_event", "sequence_event_criteria", 
        "sequence_event_criterion", "sequence_event_constraint", "temporal_constraint", 
        "sequence_temporal_filter", "sequence_event_event", "selected_sequence_event", 
        "unselected_sequence_event", "instance_event", "instance_event_criteria", 
        "instance_event_criterion", "instance_event_event", "instance_event_position", 
        "aggregation_qualified", "specific_instance", "instance_event_position_error", 
        "qualified_simple_event", "qualified_derived_event", "sequence_event_constraint_error", 
        "derived_event_error", "derived_uniqueness_filter", "derived_uniqueness_filter_window", 
        "derived_fixed_window_uniqueness_filter", "derived_rolling_window_uniqueness_filter", 
        "derived_event_int", "simple_event", "condition_occurrence_event", 
        "drug_exposure_event", "measurement_event", "observation_event", 
        "procedure_occurrence_event", "visit_occurrence_event", "condition_occurrence_event_definition", 
        "drug_exposure_event_definition", "measurement_event_definition", 
        "observation_event_definition", "procedure_occurrence_event_definition", 
        "visit_occurrence_event_definition", "condition_occurrence_event_criteria", 
        "condition_occurrence_event_filter", "condition_occurrence_concept_filters", 
        "condition_occurrence_concept_group_filter", "condition_occurrence_concept_filter", 
        "condition_occurrence_uniqueness_filters", "condition_occurrence_uniqueness_filter", 
        "condition_occurrence_related_entity_filters", "condition_occurrence_related_entity_filter", 
        "condition_occurrence_sub_filter", "condition_occurrence_error_sub_filter", 
        "condition_occurrence_error_filter", "drug_exposure_event_criteria", 
        "drug_exposure_event_filter", "drug_exposure_concept_filters", "drug_exposure_concept_group_filter", 
        "drug_exposure_concept_filter", "drug_exposure_numeric_filters", 
        "drug_exposure_float_filter", "drug_exposure_int_filter", "drug_exposure_uniqueness_filters", 
        "drug_exposure_uniqueness_filter", "drug_exposure_related_entity_filters", 
        "drug_exposure_related_entity_filter", "drug_exposure_error_filter", 
        "measurement_event_criteria", "measurement_event_filter", "measurement_concept_filters", 
        "measurement_concept_group_filter", "measurement_concept_filter", 
        "measurement_numeric_filters", "measurement_float_filter", "measurement_uniqueness_filters", 
        "measurement_uniqueness_filter", "measurement_related_entity_filters", 
        "measurement_related_entity_filter", "measurement_error_filter", 
        "observation_event_criteria", "observation_event_filter", "observation_concept_filters", 
        "observation_concept_group_filter", "observation_concept_filter", 
        "observation_numeric_filters", "observation_float_filter", "observation_uniqueness_filters", 
        "observation_uniqueness_filter", "observation_related_entity_filters", 
        "observation_related_entity_filter", "observation_error_filter", 
        "procedure_occurrence_event_criteria", "procedure_occurrence_event_filter", 
        "procedure_occurrence_concept_filters", "procedure_occurrence_concept_group_filter", 
        "procedure_occurrence_concept_filter", "procedure_occurrence_numeric_filters", 
        "procedure_occurrence_int_filter", "procedure_occurrence_uniqueness_filters", 
        "procedure_occurrence_uniqueness_filter", "procedure_occurrence_related_entity_filters", 
        "procedure_occurrence_related_entity_filter", "procedure_occurrence_error_filter", 
        "provider_concept_filters", "provider_concept_group_filter", "provider_concept_filter", 
        "provider_sub_filter", "provider_error_sub_filter", "visit_occurrence_event_criteria", 
        "visit_occurrence_event_filter", "visit_occurrence_concept_filters", 
        "visit_occurrence_concept_group_filter", "visit_occurrence_concept_filter", 
        "visit_occurrence_uniqueness_filters", "visit_occurrence_uniqueness_filter", 
        "visit_occurrence_related_entity_filters", "visit_occurrence_related_entity_filter", 
        "visit_occurrence_sub_filter", "visit_occurrence_error_sub_filter", 
        "visit_occurrence_error_filter", "comparison_op", "simple_uniqueness_filter", 
        "simple_uniqueness_filter_window", "fixed_window_uniqueness_filter", 
        "rolling_window_uniqueness_filter", "simple_event_float", "simple_event_int", 
        "concept_group_selection",
    ];

    public get grammarFileName(): string { return "IndexDate.g4"; }
    public get literalNames(): (string | null)[] { return IndexDate.literalNames; }
    public get symbolicNames(): (string | null)[] { return IndexDate.symbolicNames; }
    public get ruleNames(): string[] { return IndexDate.ruleNames; }
    public get serializedATN(): number[] { return IndexDate._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, IndexDate._ATN, IndexDate.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public index_date(): Index_dateContext {
        let localContext = new Index_dateContext(this.context, this.state);
        this.enterRule(localContext, 0, IndexDate.RULE_index_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 292;
            this.match(IndexDate.INDEX_DATE);
            this.state = 293;
            this.match(IndexDate.EQ);
            this.state = 294;
            this.index_date_definition();
            this.state = 295;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_definition(): Index_date_definitionContext {
        let localContext = new Index_date_definitionContext(this.context, this.state);
        this.enterRule(localContext, 2, IndexDate.RULE_index_date_definition);
        try {
            this.state = 301;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 0, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 297;
                this.calendar_date();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 298;
                this.calendarError();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 299;
                this.index_event_date();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 300;
                this.index_event_date_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendar_date(): Calendar_dateContext {
        let localContext = new Calendar_dateContext(this.context, this.state);
        this.enterRule(localContext, 4, IndexDate.RULE_calendar_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 303;
            localContext._index_date_type = this.match(IndexDate.CALENDAR_DATE);
            this.state = 304;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 305;
            this.match(IndexDate.DATE);
            this.state = 306;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date(): Index_event_dateContext {
        let localContext = new Index_event_dateContext(this.context, this.state);
        this.enterRule(localContext, 6, IndexDate.RULE_index_event_date);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 308;
            localContext._index_date_type = this.match(IndexDate.EVENT);
            this.state = 309;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 310;
            localContext._date = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 60 || _la === 156)) {
                localContext._date = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 313;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 84) {
                {
                this.state = 311;
                this.match(IndexDate.COMMA);
                this.state = 312;
                this.index_date_bounds();
                }
            }

            this.state = 315;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_bounds(): Index_date_boundsContext {
        let localContext = new Index_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 8, IndexDate.RULE_index_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 319;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 2, this.context) ) {
            case 1:
                {
                this.state = 317;
                this.lower_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 318;
                this.lower_date_bounds_error();
                }
                break;
            }
            this.state = 321;
            this.match(IndexDate.COMMA);
            this.state = 324;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 3, this.context) ) {
            case 1:
                {
                this.state = 322;
                this.upper_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 323;
                this.upper_date_bounds_error();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds(): Upper_date_boundsContext {
        let localContext = new Upper_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 10, IndexDate.RULE_upper_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 326;
            this.match(IndexDate.UPPER_DATE_BOUND);
            this.state = 327;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 328;
            this.match(IndexDate.DATE);
            this.state = 329;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds(): Lower_date_boundsContext {
        let localContext = new Lower_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 12, IndexDate.RULE_lower_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 331;
            this.match(IndexDate.LOWER_DATE_BOUND);
            this.state = 332;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 333;
            this.match(IndexDate.DATE);
            this.state = 334;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendarError(): CalendarErrorContext {
        let localContext = new CalendarErrorContext(this.context, this.state);
        this.enterRule(localContext, 14, IndexDate.RULE_calendarError);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 336;
            this.match(IndexDate.CALENDAR_DATE);
            this.state = 337;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 338;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date_error(): Index_event_date_errorContext {
        let localContext = new Index_event_date_errorContext(this.context, this.state);
        this.enterRule(localContext, 16, IndexDate.RULE_index_event_date_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 340;
            this.match(IndexDate.EVENT);
            this.state = 341;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 342;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext {
        let localContext = new Lower_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 18, IndexDate.RULE_lower_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 344;
            this.match(IndexDate.LOWER_DATE_BOUND);
            this.state = 345;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 346;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext {
        let localContext = new Upper_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 20, IndexDate.RULE_upper_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 348;
            this.match(IndexDate.UPPER_DATE_BOUND);
            this.state = 349;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 350;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event(): Derived_eventContext {
        let localContext = new Derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 22, IndexDate.RULE_derived_event);
        try {
            this.state = 355;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MERGED_EVENT_NAME:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 352;
                this.merged_event();
                }
                break;
            case IndexDate.SEQUENCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 353;
                this.sequence_event();
                }
                break;
            case IndexDate.INSTANCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 354;
                this.instance_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event(): Merged_eventContext {
        let localContext = new Merged_eventContext(this.context, this.state);
        this.enterRule(localContext, 24, IndexDate.RULE_merged_event);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 357;
            this.match(IndexDate.MERGED_EVENT_NAME);
            this.state = 358;
            this.match(IndexDate.EQ);
            this.state = 359;
            this.match(IndexDate.MERGED_EVENT);
            this.state = 360;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 361;
            this.merged_event_criteria();
            this.state = 364;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 84) {
                {
                this.state = 362;
                this.match(IndexDate.COMMA);
                this.state = 363;
                this.merged_event_filter_criterion();
                }
            }

            this.state = 366;
            this.match(IndexDate.CLOSE_PAREN);
            this.state = 367;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        let localContext = new Merged_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 26, IndexDate.RULE_merged_event_criteria);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 369;
            this.merged_event_criterion();
            this.state = 372;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 370;
                    this.match(IndexDate.COMMA);
                    this.state = 371;
                    this.merged_event_criterion();
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 374;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 6, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criterion(): Merged_event_criterionContext {
        let localContext = new Merged_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 28, IndexDate.RULE_merged_event_criterion);
        try {
            this.state = 378;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 7, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 376;
                this.merged_event_event();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 377;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext {
        let localContext = new Merged_event_filter_criterionContext(this.context, this.state);
        this.enterRule(localContext, 30, IndexDate.RULE_merged_event_filter_criterion);
        try {
            this.state = 382;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 8, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 380;
                this.merged_event_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 381;
                this.merged_event_filter_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_event(): Merged_event_eventContext {
        let localContext = new Merged_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 32, IndexDate.RULE_merged_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 384;
            this.match(IndexDate.DERIVED_EVENT);
            this.state = 385;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 388;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case IndexDate.QUALIFIED_MEASUREMENT_ALIAS:
            case IndexDate.QUALIFIED_OBSERVATION_ALIAS:
            case IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 386;
                this.qualified_simple_event();
                }
                break;
            case IndexDate.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 387;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 390;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter(): Merged_event_filterContext {
        let localContext = new Merged_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 34, IndexDate.RULE_merged_event_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 392;
            this.merged_event_uniqueness_filter();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        let localContext = new Merged_event_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 36, IndexDate.RULE_merged_event_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 394;
            this.match(IndexDate.UF);
            this.state = 395;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 396;
            this.merged_event_uniqueness_filter_criteria();
            this.state = 397;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        let localContext = new Merged_event_uniqueness_filter_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 38, IndexDate.RULE_merged_event_uniqueness_filter_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 401;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MINIMUM_BETWEEN:
                {
                this.state = 399;
                this.derived_uniqueness_filter();
                }
                break;
            case IndexDate.FIXED_WINDOW:
            case IndexDate.ROLLING_WINDOW:
                {
                this.state = 400;
                this.derived_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 403;
            localContext._date_attr = this.match(IndexDate.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext {
        let localContext = new Merged_event_filter_errorContext(this.context, this.state);
        this.enterRule(localContext, 40, IndexDate.RULE_merged_event_filter_error);
        try {
            this.state = 459;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 11, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 405;
                this.match(IndexDate.UF);
                this.state = 406;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 407;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 408;
                this.match(IndexDate.UF);
                this.state = 409;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 410;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 411;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 412;
                this.match(IndexDate.UF);
                this.state = 413;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 414;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 415;
                this.derived_event_int();
                this.state = 416;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 418;
                this.match(IndexDate.UF);
                this.state = 419;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 420;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 421;
                this.derived_event_int();
                this.state = 422;
                this.match(IndexDate.TIME_UNIT);
                this.state = 423;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 425;
                this.match(IndexDate.UF);
                this.state = 426;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 427;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 428;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 429;
                this.match(IndexDate.UF);
                this.state = 430;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 431;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 432;
                this.derived_event_int();
                this.state = 433;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 435;
                this.match(IndexDate.UF);
                this.state = 436;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 437;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 438;
                this.derived_event_int();
                this.state = 439;
                this.match(IndexDate.TIME_UNIT);
                this.state = 440;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 442;
                this.match(IndexDate.UF);
                this.state = 443;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 444;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 445;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 446;
                this.match(IndexDate.UF);
                this.state = 447;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 448;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 449;
                this.derived_event_int();
                this.state = 450;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 452;
                this.match(IndexDate.UF);
                this.state = 453;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 454;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 455;
                this.derived_event_int();
                this.state = 456;
                this.match(IndexDate.TIME_UNIT);
                this.state = 457;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event(): Sequence_eventContext {
        let localContext = new Sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 42, IndexDate.RULE_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 461;
            this.match(IndexDate.SEQUENCE_EVENT_NAME);
            this.state = 462;
            this.match(IndexDate.EQ);
            this.state = 463;
            this.match(IndexDate.SEQUENCE_EVENT);
            this.state = 464;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 465;
            this.sequence_event_criteria();
            this.state = 466;
            this.match(IndexDate.CLOSE_PAREN);
            this.state = 467;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        let localContext = new Sequence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 44, IndexDate.RULE_sequence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 469;
            this.sequence_event_criterion();
            this.state = 474;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 470;
                this.match(IndexDate.COMMA);
                this.state = 471;
                this.sequence_event_criterion();
                }
                }
                this.state = 476;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criterion(): Sequence_event_criterionContext {
        let localContext = new Sequence_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 46, IndexDate.RULE_sequence_event_criterion);
        try {
            this.state = 481;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 13, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 477;
                this.sequence_event_constraint();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 478;
                this.sequence_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 479;
                this.sequence_event_constraint_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 480;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint(): Sequence_event_constraintContext {
        let localContext = new Sequence_event_constraintContext(this.context, this.state);
        this.enterRule(localContext, 48, IndexDate.RULE_sequence_event_constraint);
        try {
            this.state = 485;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.ANY_ORDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 483;
                this.match(IndexDate.ANY_ORDER);
                }
                break;
            case IndexDate.TC:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 484;
                this.temporal_constraint();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public temporal_constraint(): Temporal_constraintContext {
        let localContext = new Temporal_constraintContext(this.context, this.state);
        this.enterRule(localContext, 50, IndexDate.RULE_temporal_constraint);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 487;
            this.match(IndexDate.TC);
            this.state = 488;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 489;
            this.sequence_temporal_filter();
            this.state = 490;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        let localContext = new Sequence_temporal_filterContext(this.context, this.state);
        this.enterRule(localContext, 52, IndexDate.RULE_sequence_temporal_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 492;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 116)) & ~0x1F) === 0 && ((1 << (_la - 116)) & 7) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 493;
            this.match(IndexDate.INT);
            this.state = 494;
            this.match(IndexDate.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_event(): Sequence_event_eventContext {
        let localContext = new Sequence_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 54, IndexDate.RULE_sequence_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 496;
            this.match(IndexDate.DERIVED_EVENT);
            this.state = 497;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 500;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 15, this.context) ) {
            case 1:
                {
                this.state = 498;
                this.selected_sequence_event();
                }
                break;
            case 2:
                {
                this.state = 499;
                this.unselected_sequence_event();
                }
                break;
            }
            this.state = 502;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public selected_sequence_event(): Selected_sequence_eventContext {
        let localContext = new Selected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 56, IndexDate.RULE_selected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 506;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case IndexDate.QUALIFIED_MEASUREMENT_ALIAS:
            case IndexDate.QUALIFIED_OBSERVATION_ALIAS:
            case IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 504;
                this.qualified_simple_event();
                }
                break;
            case IndexDate.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 505;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 508;
            this.match(IndexDate.COMMA);
            this.state = 509;
            this.match(IndexDate.IS_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext {
        let localContext = new Unselected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 58, IndexDate.RULE_unselected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 513;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case IndexDate.QUALIFIED_MEASUREMENT_ALIAS:
            case IndexDate.QUALIFIED_OBSERVATION_ALIAS:
            case IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 511;
                this.qualified_simple_event();
                }
                break;
            case IndexDate.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 512;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event(): Instance_eventContext {
        let localContext = new Instance_eventContext(this.context, this.state);
        this.enterRule(localContext, 60, IndexDate.RULE_instance_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 515;
            this.match(IndexDate.INSTANCE_EVENT_NAME);
            this.state = 516;
            this.match(IndexDate.EQ);
            this.state = 517;
            this.match(IndexDate.INSTANCE_EVENT);
            this.state = 518;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 519;
            this.instance_event_criteria();
            this.state = 520;
            this.match(IndexDate.CLOSE_PAREN);
            this.state = 521;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        let localContext = new Instance_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 62, IndexDate.RULE_instance_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 523;
            this.instance_event_criterion();
            this.state = 526;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 524;
                this.match(IndexDate.COMMA);
                this.state = 525;
                this.instance_event_criterion();
                }
                }
                this.state = 528;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (_la === 84);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criterion(): Instance_event_criterionContext {
        let localContext = new Instance_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 64, IndexDate.RULE_instance_event_criterion);
        try {
            this.state = 535;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 19, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 531;
                this.instance_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 532;
                this.derived_event_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 533;
                this.instance_event_position();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 534;
                this.instance_event_position_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_event(): Instance_event_eventContext {
        let localContext = new Instance_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 66, IndexDate.RULE_instance_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 537;
            this.match(IndexDate.DERIVED_EVENT);
            this.state = 538;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 541;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case IndexDate.QUALIFIED_MEASUREMENT_ALIAS:
            case IndexDate.QUALIFIED_OBSERVATION_ALIAS:
            case IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 539;
                this.qualified_simple_event();
                }
                break;
            case IndexDate.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 540;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 543;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position(): Instance_event_positionContext {
        let localContext = new Instance_event_positionContext(this.context, this.state);
        this.enterRule(localContext, 68, IndexDate.RULE_instance_event_position);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 545;
            this.match(IndexDate.POSITION);
            this.state = 546;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 549;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MAX:
            case IndexDate.MIN:
                {
                this.state = 547;
                this.aggregation_qualified();
                }
                break;
            case IndexDate.INDEX:
                {
                this.state = 548;
                this.specific_instance();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 551;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext {
        let localContext = new Aggregation_qualifiedContext(this.context, this.state);
        this.enterRule(localContext, 70, IndexDate.RULE_aggregation_qualified);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 553;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 96 || _la === 97)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public specific_instance(): Specific_instanceContext {
        let localContext = new Specific_instanceContext(this.context, this.state);
        this.enterRule(localContext, 72, IndexDate.RULE_specific_instance);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 555;
            this.match(IndexDate.INDEX);
            this.state = 556;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 557;
            this.match(IndexDate.INT);
            this.state = 558;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position_error(): Instance_event_position_errorContext {
        let localContext = new Instance_event_position_errorContext(this.context, this.state);
        this.enterRule(localContext, 74, IndexDate.RULE_instance_event_position_error);
        try {
            this.state = 569;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 22, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 560;
                this.match(IndexDate.POSITION);
                this.state = 561;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 562;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 563;
                this.match(IndexDate.POSITION);
                this.state = 564;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 565;
                this.match(IndexDate.INDEX);
                this.state = 566;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 567;
                this.match(IndexDate.CLOSE_PAREN);
                this.state = 568;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_simple_event(): Qualified_simple_eventContext {
        let localContext = new Qualified_simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 76, IndexDate.RULE_qualified_simple_event);
        try {
            this.state = 589;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 571;
                this.match(IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS);
                this.state = 572;
                this.match(IndexDate.PERIOD);
                this.state = 573;
                this.match(IndexDate.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 574;
                this.match(IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS);
                this.state = 575;
                this.match(IndexDate.PERIOD);
                this.state = 576;
                this.match(IndexDate.DRUG_EXPOSURE_DATE_ATTRIBUTE);
                }
                break;
            case IndexDate.QUALIFIED_MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 577;
                this.match(IndexDate.QUALIFIED_MEASUREMENT_ALIAS);
                this.state = 578;
                this.match(IndexDate.PERIOD);
                this.state = 579;
                this.match(IndexDate.MEASUREMENT_DATE_ATTRIBUTE);
                }
                break;
            case IndexDate.QUALIFIED_OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 580;
                this.match(IndexDate.QUALIFIED_OBSERVATION_ALIAS);
                this.state = 581;
                this.match(IndexDate.PERIOD);
                this.state = 582;
                this.match(IndexDate.OBSERVATION_DATE_ATTRIBUTE);
                }
                break;
            case IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 583;
                this.match(IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS);
                this.state = 584;
                this.match(IndexDate.PERIOD);
                this.state = 585;
                this.match(IndexDate.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 586;
                this.match(IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS);
                this.state = 587;
                this.match(IndexDate.PERIOD);
                this.state = 588;
                this.match(IndexDate.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_derived_event(): Qualified_derived_eventContext {
        let localContext = new Qualified_derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 78, IndexDate.RULE_qualified_derived_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 591;
            this.match(IndexDate.QUALIFIED_DERIVED_EVENT_NAME);
            this.state = 592;
            this.match(IndexDate.PERIOD);
            this.state = 593;
            this.match(IndexDate.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext {
        let localContext = new Sequence_event_constraint_errorContext(this.context, this.state);
        this.enterRule(localContext, 80, IndexDate.RULE_sequence_event_constraint_error);
        let _la: number;
        try {
            this.state = 607;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 24, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 595;
                this.match(IndexDate.TC);
                this.state = 596;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 597;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 598;
                this.match(IndexDate.TC);
                this.state = 599;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 600;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 116)) & ~0x1F) === 0 && ((1 << (_la - 116)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 601;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 602;
                this.match(IndexDate.TC);
                this.state = 603;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 604;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 116)) & ~0x1F) === 0 && ((1 << (_la - 116)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 605;
                this.match(IndexDate.INT);
                this.state = 606;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_error(): Derived_event_errorContext {
        let localContext = new Derived_event_errorContext(this.context, this.state);
        this.enterRule(localContext, 82, IndexDate.RULE_derived_event_error);
        let _la: number;
        try {
            this.state = 621;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 25, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 609;
                this.match(IndexDate.DERIVED_EVENT);
                this.state = 610;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 611;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 612;
                this.match(IndexDate.DERIVED_EVENT);
                this.state = 613;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 614;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 615;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 616;
                this.match(IndexDate.DERIVED_EVENT);
                this.state = 617;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 618;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 619;
                this.match(IndexDate.PERIOD);
                this.state = 620;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext {
        let localContext = new Derived_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 84, IndexDate.RULE_derived_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 623;
            this.match(IndexDate.MINIMUM_BETWEEN);
            this.state = 624;
            this.derived_event_int();
            this.state = 625;
            this.match(IndexDate.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext {
        let localContext = new Derived_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 86, IndexDate.RULE_derived_uniqueness_filter_window);
        try {
            this.state = 629;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 627;
                this.derived_fixed_window_uniqueness_filter();
                }
                break;
            case IndexDate.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 628;
                this.derived_rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext {
        let localContext = new Derived_fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 88, IndexDate.RULE_derived_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 631;
            this.match(IndexDate.FIXED_WINDOW);
            this.state = 632;
            this.derived_event_int();
            this.state = 633;
            this.match(IndexDate.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext {
        let localContext = new Derived_rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 90, IndexDate.RULE_derived_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 635;
            this.match(IndexDate.ROLLING_WINDOW);
            this.state = 636;
            this.derived_event_int();
            this.state = 637;
            this.match(IndexDate.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_int(): Derived_event_intContext {
        let localContext = new Derived_event_intContext(this.context, this.state);
        this.enterRule(localContext, 92, IndexDate.RULE_derived_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 639;
            this.match(IndexDate.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event(): Simple_eventContext {
        let localContext = new Simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 94, IndexDate.RULE_simple_event);
        try {
            this.state = 647;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 641;
                this.condition_occurrence_event();
                }
                break;
            case IndexDate.DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 642;
                this.drug_exposure_event();
                }
                break;
            case IndexDate.MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 643;
                this.measurement_event();
                }
                break;
            case IndexDate.OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 644;
                this.observation_event();
                }
                break;
            case IndexDate.PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 645;
                this.procedure_occurrence_event();
                }
                break;
            case IndexDate.VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 646;
                this.visit_occurrence_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext {
        let localContext = new Condition_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 96, IndexDate.RULE_condition_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 649;
            localContext._event_name = this.match(IndexDate.CONDITION_OCCURRENCE_ALIAS);
            this.state = 650;
            this.match(IndexDate.EQ);
            this.state = 651;
            localContext._event_definition = this.condition_occurrence_event_definition();
            this.state = 652;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event(): Drug_exposure_eventContext {
        let localContext = new Drug_exposure_eventContext(this.context, this.state);
        this.enterRule(localContext, 98, IndexDate.RULE_drug_exposure_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 654;
            localContext._event_name = this.match(IndexDate.DRUG_EXPOSURE_ALIAS);
            this.state = 655;
            this.match(IndexDate.EQ);
            this.state = 656;
            localContext._event_definition = this.drug_exposure_event_definition();
            this.state = 657;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event(): Measurement_eventContext {
        let localContext = new Measurement_eventContext(this.context, this.state);
        this.enterRule(localContext, 100, IndexDate.RULE_measurement_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 659;
            localContext._event_name = this.match(IndexDate.MEASUREMENT_ALIAS);
            this.state = 660;
            this.match(IndexDate.EQ);
            this.state = 661;
            localContext._event_definition = this.measurement_event_definition();
            this.state = 662;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event(): Observation_eventContext {
        let localContext = new Observation_eventContext(this.context, this.state);
        this.enterRule(localContext, 102, IndexDate.RULE_observation_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 664;
            localContext._event_name = this.match(IndexDate.OBSERVATION_ALIAS);
            this.state = 665;
            this.match(IndexDate.EQ);
            this.state = 666;
            localContext._event_definition = this.observation_event_definition();
            this.state = 667;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext {
        let localContext = new Procedure_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 104, IndexDate.RULE_procedure_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 669;
            localContext._event_name = this.match(IndexDate.PROCEDURE_OCCURRENCE_ALIAS);
            this.state = 670;
            this.match(IndexDate.EQ);
            this.state = 671;
            localContext._event_definition = this.procedure_occurrence_event_definition();
            this.state = 672;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext {
        let localContext = new Visit_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 106, IndexDate.RULE_visit_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 674;
            localContext._event_name = this.match(IndexDate.VISIT_OCCURRENCE_ALIAS);
            this.state = 675;
            this.match(IndexDate.EQ);
            this.state = 676;
            localContext._event_definition = this.visit_occurrence_event_definition();
            this.state = 677;
            this.match(IndexDate.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        let localContext = new Condition_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 108, IndexDate.RULE_condition_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 679;
            localContext._prefix = this.match(IndexDate.CONDITION_OCCURRENCE);
            this.state = 680;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 682;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75513856) !== 0)) {
                {
                this.state = 681;
                localContext._criteria = this.condition_occurrence_event_criteria();
                }
            }

            this.state = 684;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        let localContext = new Drug_exposure_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 110, IndexDate.RULE_drug_exposure_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 686;
            localContext._prefix = this.match(IndexDate.DRUG_EXPOSURE);
            this.state = 687;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 689;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 688;
                localContext._criteria = this.drug_exposure_event_criteria();
                }
            }

            this.state = 691;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        let localContext = new Measurement_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 112, IndexDate.RULE_measurement_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 693;
            localContext._prefix = this.match(IndexDate.MEASUREMENT);
            this.state = 694;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 696;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 695;
                localContext._criteria = this.measurement_event_criteria();
                }
            }

            this.state = 698;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        let localContext = new Observation_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 114, IndexDate.RULE_observation_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 700;
            localContext._prefix = this.match(IndexDate.OBSERVATION);
            this.state = 701;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 703;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 702;
                localContext._criteria = this.observation_event_criteria();
                }
            }

            this.state = 705;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        let localContext = new Procedure_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 116, IndexDate.RULE_procedure_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 707;
            localContext._prefix = this.match(IndexDate.PROCEDURE_OCCURRENCE);
            this.state = 708;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 710;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 709;
                localContext._criteria = this.procedure_occurrence_event_criteria();
                }
            }

            this.state = 712;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        let localContext = new Visit_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 118, IndexDate.RULE_visit_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 714;
            localContext._prefix = this.match(IndexDate.VISIT_OCCURRENCE);
            this.state = 715;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 717;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75513856) !== 0)) {
                {
                this.state = 716;
                localContext._criteria = this.visit_occurrence_event_criteria();
                }
            }

            this.state = 719;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext {
        let localContext = new Condition_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 120, IndexDate.RULE_condition_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 721;
            this.condition_occurrence_event_filter();
            this.state = 726;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 722;
                this.match(IndexDate.COMMA);
                this.state = 723;
                this.condition_occurrence_event_filter();
                }
                }
                this.state = 728;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext {
        let localContext = new Condition_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 122, IndexDate.RULE_condition_occurrence_event_filter);
        try {
            this.state = 733;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 35, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 729;
                this.condition_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 730;
                this.condition_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 731;
                this.condition_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 732;
                this.condition_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext {
        let localContext = new Condition_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 124, IndexDate.RULE_condition_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 735;
            this.match(IndexDate.CF);
            this.state = 736;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 739;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 36, this.context) ) {
            case 1:
                {
                this.state = 737;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 738;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            this.state = 741;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext {
        let localContext = new Condition_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 126, IndexDate.RULE_condition_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 743;
            this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 744;
            this.match(IndexDate.IN);
            this.state = 745;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext {
        let localContext = new Condition_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 128, IndexDate.RULE_condition_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 747;
            this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 748;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 749;
            this.match(IndexDate.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext {
        let localContext = new Condition_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 130, IndexDate.RULE_condition_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 751;
            this.match(IndexDate.UF);
            this.state = 752;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 753;
            this.condition_occurrence_uniqueness_filter();
            this.state = 754;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        let localContext = new Condition_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 132, IndexDate.RULE_condition_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 758;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MINIMUM_BETWEEN:
                {
                this.state = 756;
                this.simple_uniqueness_filter();
                }
                break;
            case IndexDate.FIXED_WINDOW:
            case IndexDate.ROLLING_WINDOW:
                {
                this.state = 757;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 760;
            localContext._date_attr = this.match(IndexDate.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext {
        let localContext = new Condition_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 134, IndexDate.RULE_condition_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 762;
            this.match(IndexDate.RF);
            this.state = 763;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 764;
            this.condition_occurrence_related_entity_filter();
            this.state = 765;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        let localContext = new Condition_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 136, IndexDate.RULE_condition_occurrence_related_entity_filter);
        try {
            this.state = 769;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 767;
                this.provider_sub_filter();
                }
                break;
            case IndexDate.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 768;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext {
        let localContext = new Condition_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 138, IndexDate.RULE_condition_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 771;
            this.match(IndexDate.CONDITION_OCCURRENCE);
            this.state = 774;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 39, this.context) ) {
            case 1:
                {
                this.state = 772;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 773;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext {
        let localContext = new Condition_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 140, IndexDate.RULE_condition_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 786;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 40, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 777;
                this.match(IndexDate.CONDITION_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 778;
                this.match(IndexDate.CONDITION_OCCURRENCE);
                this.state = 779;
                this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 780;
                this.match(IndexDate.CONDITION_OCCURRENCE);
                this.state = 781;
                this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 782;
                this.match(IndexDate.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 783;
                this.match(IndexDate.CONDITION_OCCURRENCE);
                this.state = 784;
                this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 785;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext {
        let localContext = new Condition_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 142, IndexDate.RULE_condition_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 872;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 41, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 788;
                this.match(IndexDate.CF);
                this.state = 789;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 790;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 791;
                this.match(IndexDate.CF);
                this.state = 792;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 793;
                this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 794;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 795;
                this.match(IndexDate.CF);
                this.state = 796;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 797;
                this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 798;
                this.match(IndexDate.IN);
                this.state = 799;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 800;
                this.match(IndexDate.CF);
                this.state = 801;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 802;
                this.match(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 803;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 804;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 805;
                this.match(IndexDate.UF);
                this.state = 806;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 807;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 808;
                this.match(IndexDate.UF);
                this.state = 809;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 810;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 811;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 812;
                this.match(IndexDate.UF);
                this.state = 813;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 814;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 815;
                this.simple_event_int();
                this.state = 816;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 818;
                this.match(IndexDate.UF);
                this.state = 819;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 820;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 821;
                this.simple_event_int();
                this.state = 822;
                this.match(IndexDate.TIME_UNIT);
                this.state = 823;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 825;
                this.match(IndexDate.UF);
                this.state = 826;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 827;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 828;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 829;
                this.match(IndexDate.UF);
                this.state = 830;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 831;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 832;
                this.simple_event_int();
                this.state = 833;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 835;
                this.match(IndexDate.UF);
                this.state = 836;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 837;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 838;
                this.simple_event_int();
                this.state = 839;
                this.match(IndexDate.TIME_UNIT);
                this.state = 840;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 842;
                this.match(IndexDate.UF);
                this.state = 843;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 844;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 845;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 846;
                this.match(IndexDate.UF);
                this.state = 847;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 848;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 849;
                this.simple_event_int();
                this.state = 850;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 852;
                this.match(IndexDate.UF);
                this.state = 853;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 854;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 855;
                this.simple_event_int();
                this.state = 856;
                this.match(IndexDate.TIME_UNIT);
                this.state = 857;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 859;
                this.match(IndexDate.RF);
                this.state = 860;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 861;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 862;
                this.match(IndexDate.RF);
                this.state = 863;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 864;
                this.provider_error_sub_filter();
                this.state = 865;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 867;
                this.match(IndexDate.RF);
                this.state = 868;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 869;
                this.visit_occurrence_error_sub_filter();
                this.state = 870;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext {
        let localContext = new Drug_exposure_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 144, IndexDate.RULE_drug_exposure_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 874;
            this.drug_exposure_event_filter();
            this.state = 879;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 875;
                this.match(IndexDate.COMMA);
                this.state = 876;
                this.drug_exposure_event_filter();
                }
                }
                this.state = 881;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext {
        let localContext = new Drug_exposure_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 146, IndexDate.RULE_drug_exposure_event_filter);
        try {
            this.state = 887;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 43, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 882;
                this.drug_exposure_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 883;
                this.drug_exposure_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 884;
                this.drug_exposure_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 885;
                this.drug_exposure_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 886;
                this.drug_exposure_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext {
        let localContext = new Drug_exposure_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 148, IndexDate.RULE_drug_exposure_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 889;
            this.match(IndexDate.CF);
            this.state = 890;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 893;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 44, this.context) ) {
            case 1:
                {
                this.state = 891;
                this.drug_exposure_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 892;
                this.drug_exposure_concept_filter();
                }
                break;
            }
            this.state = 895;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext {
        let localContext = new Drug_exposure_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 150, IndexDate.RULE_drug_exposure_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 897;
            this.match(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 898;
            this.match(IndexDate.IN);
            this.state = 899;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext {
        let localContext = new Drug_exposure_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 152, IndexDate.RULE_drug_exposure_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 901;
            this.match(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 902;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 903;
            this.match(IndexDate.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext {
        let localContext = new Drug_exposure_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 154, IndexDate.RULE_drug_exposure_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 905;
            this.match(IndexDate.NF);
            this.state = 906;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 909;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.QUANTITY:
                {
                this.state = 907;
                this.drug_exposure_float_filter();
                }
                break;
            case IndexDate.DRUG_EXPOSURE_INT_ATTRIBUTE:
                {
                this.state = 908;
                this.drug_exposure_int_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 911;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext {
        let localContext = new Drug_exposure_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 156, IndexDate.RULE_drug_exposure_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 913;
            this.match(IndexDate.QUANTITY);
            this.state = 914;
            this.comparison_op();
            this.state = 915;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext {
        let localContext = new Drug_exposure_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 158, IndexDate.RULE_drug_exposure_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 917;
            this.match(IndexDate.DRUG_EXPOSURE_INT_ATTRIBUTE);
            this.state = 918;
            this.comparison_op();
            this.state = 919;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext {
        let localContext = new Drug_exposure_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 160, IndexDate.RULE_drug_exposure_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 921;
            this.match(IndexDate.UF);
            this.state = 922;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 923;
            this.drug_exposure_uniqueness_filter();
            this.state = 924;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        let localContext = new Drug_exposure_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 162, IndexDate.RULE_drug_exposure_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 928;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MINIMUM_BETWEEN:
                {
                this.state = 926;
                this.simple_uniqueness_filter();
                }
                break;
            case IndexDate.FIXED_WINDOW:
            case IndexDate.ROLLING_WINDOW:
                {
                this.state = 927;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 930;
            this.match(IndexDate.DRUG_EXPOSURE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext {
        let localContext = new Drug_exposure_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 164, IndexDate.RULE_drug_exposure_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 932;
            this.match(IndexDate.RF);
            this.state = 933;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 934;
            this.drug_exposure_related_entity_filter();
            this.state = 935;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        let localContext = new Drug_exposure_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 166, IndexDate.RULE_drug_exposure_related_entity_filter);
        try {
            this.state = 939;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 937;
                this.provider_sub_filter();
                }
                break;
            case IndexDate.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 938;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext {
        let localContext = new Drug_exposure_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 168, IndexDate.RULE_drug_exposure_error_filter);
        let _la: number;
        try {
            this.state = 1048;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 48, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 941;
                this.match(IndexDate.CF);
                this.state = 942;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 943;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 944;
                this.match(IndexDate.CF);
                this.state = 945;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 946;
                this.match(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 947;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 948;
                this.match(IndexDate.CF);
                this.state = 949;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 950;
                this.match(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 951;
                this.match(IndexDate.IN);
                this.state = 952;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 953;
                this.match(IndexDate.CF);
                this.state = 954;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 955;
                this.match(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 956;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 957;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 958;
                this.match(IndexDate.NF);
                this.state = 959;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 960;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 961;
                this.match(IndexDate.NF);
                this.state = 962;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 963;
                this.match(IndexDate.QUANTITY);
                this.state = 964;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 965;
                this.match(IndexDate.NF);
                this.state = 966;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 967;
                this.match(IndexDate.QUANTITY);
                this.state = 968;
                this.comparison_op();
                this.state = 969;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 971;
                this.match(IndexDate.NF);
                this.state = 972;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 973;
                this.match(IndexDate.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 974;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 975;
                this.match(IndexDate.NF);
                this.state = 976;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 977;
                this.match(IndexDate.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 978;
                this.comparison_op();
                this.state = 979;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 981;
                this.match(IndexDate.UF);
                this.state = 982;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 983;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 984;
                this.match(IndexDate.UF);
                this.state = 985;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 986;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 987;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 988;
                this.match(IndexDate.UF);
                this.state = 989;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 990;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 991;
                this.simple_event_int();
                this.state = 992;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 994;
                this.match(IndexDate.UF);
                this.state = 995;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 996;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 997;
                this.simple_event_int();
                this.state = 998;
                this.match(IndexDate.TIME_UNIT);
                this.state = 999;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1001;
                this.match(IndexDate.UF);
                this.state = 1002;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1003;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1004;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1005;
                this.match(IndexDate.UF);
                this.state = 1006;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1007;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1008;
                this.simple_event_int();
                this.state = 1009;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1011;
                this.match(IndexDate.UF);
                this.state = 1012;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1013;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1014;
                this.simple_event_int();
                this.state = 1015;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1016;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1018;
                this.match(IndexDate.UF);
                this.state = 1019;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1020;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1021;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1022;
                this.match(IndexDate.UF);
                this.state = 1023;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1024;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1025;
                this.simple_event_int();
                this.state = 1026;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1028;
                this.match(IndexDate.UF);
                this.state = 1029;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1030;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1031;
                this.simple_event_int();
                this.state = 1032;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1033;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1035;
                this.match(IndexDate.RF);
                this.state = 1036;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1037;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1038;
                this.match(IndexDate.RF);
                this.state = 1039;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1040;
                this.provider_error_sub_filter();
                this.state = 1041;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1043;
                this.match(IndexDate.RF);
                this.state = 1044;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1045;
                this.visit_occurrence_error_sub_filter();
                this.state = 1046;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext {
        let localContext = new Measurement_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 170, IndexDate.RULE_measurement_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1050;
            this.measurement_event_filter();
            this.state = 1055;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1051;
                this.match(IndexDate.COMMA);
                this.state = 1052;
                this.measurement_event_filter();
                }
                }
                this.state = 1057;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_filter(): Measurement_event_filterContext {
        let localContext = new Measurement_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 172, IndexDate.RULE_measurement_event_filter);
        try {
            this.state = 1063;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 50, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1058;
                this.measurement_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1059;
                this.measurement_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1060;
                this.measurement_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1061;
                this.measurement_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1062;
                this.measurement_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext {
        let localContext = new Measurement_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 174, IndexDate.RULE_measurement_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1065;
            this.match(IndexDate.CF);
            this.state = 1066;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1069;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 51, this.context) ) {
            case 1:
                {
                this.state = 1067;
                this.measurement_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1068;
                this.measurement_concept_filter();
                }
                break;
            }
            this.state = 1071;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext {
        let localContext = new Measurement_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 176, IndexDate.RULE_measurement_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1073;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 164 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1074;
            this.match(IndexDate.IN);
            this.state = 1075;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filter(): Measurement_concept_filterContext {
        let localContext = new Measurement_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 178, IndexDate.RULE_measurement_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1077;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 164 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1078;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1079;
            this.match(IndexDate.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext {
        let localContext = new Measurement_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 180, IndexDate.RULE_measurement_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1081;
            this.match(IndexDate.NF);
            this.state = 1082;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1083;
            this.measurement_float_filter();
            this.state = 1084;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        let localContext = new Measurement_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 182, IndexDate.RULE_measurement_float_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1086;
            _la = this.tokenStream.LA(1);
            if(!(_la === 158 || _la === 160)) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1087;
            this.comparison_op();
            this.state = 1088;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext {
        let localContext = new Measurement_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 184, IndexDate.RULE_measurement_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1090;
            this.match(IndexDate.UF);
            this.state = 1091;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1092;
            this.measurement_uniqueness_filter();
            this.state = 1093;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        let localContext = new Measurement_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 186, IndexDate.RULE_measurement_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1097;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MINIMUM_BETWEEN:
                {
                this.state = 1095;
                this.simple_uniqueness_filter();
                }
                break;
            case IndexDate.FIXED_WINDOW:
            case IndexDate.ROLLING_WINDOW:
                {
                this.state = 1096;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1099;
            this.match(IndexDate.MEASUREMENT_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext {
        let localContext = new Measurement_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 188, IndexDate.RULE_measurement_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1101;
            this.match(IndexDate.RF);
            this.state = 1102;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1103;
            this.measurement_related_entity_filter();
            this.state = 1104;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        let localContext = new Measurement_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 190, IndexDate.RULE_measurement_related_entity_filter);
        try {
            this.state = 1108;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1106;
                this.provider_sub_filter();
                }
                break;
            case IndexDate.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1107;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_error_filter(): Measurement_error_filterContext {
        let localContext = new Measurement_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 192, IndexDate.RULE_measurement_error_filter);
        let _la: number;
        try {
            this.state = 1221;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 54, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1110;
                this.match(IndexDate.CF);
                this.state = 1111;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1112;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1113;
                this.match(IndexDate.CF);
                this.state = 1114;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1115;
                this.match(IndexDate.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1116;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1117;
                this.match(IndexDate.CF);
                this.state = 1118;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1119;
                this.match(IndexDate.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1120;
                this.match(IndexDate.IN);
                this.state = 1121;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1122;
                this.match(IndexDate.CF);
                this.state = 1123;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1124;
                this.match(IndexDate.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1125;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1126;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1127;
                this.match(IndexDate.CF);
                this.state = 1128;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1129;
                this.match(IndexDate.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1130;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1131;
                this.match(IndexDate.CF);
                this.state = 1132;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1133;
                this.match(IndexDate.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1134;
                this.match(IndexDate.IN);
                this.state = 1135;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1136;
                this.match(IndexDate.CF);
                this.state = 1137;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1138;
                this.match(IndexDate.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1139;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1140;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1141;
                this.match(IndexDate.NF);
                this.state = 1142;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1143;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1144;
                this.match(IndexDate.NF);
                this.state = 1145;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1146;
                _la = this.tokenStream.LA(1);
                if(!(_la === 158 || _la === 160)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1147;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1148;
                this.match(IndexDate.NF);
                this.state = 1149;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1150;
                _la = this.tokenStream.LA(1);
                if(!(_la === 158 || _la === 160)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1151;
                this.comparison_op();
                this.state = 1152;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1154;
                this.match(IndexDate.UF);
                this.state = 1155;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1156;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1157;
                this.match(IndexDate.UF);
                this.state = 1158;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1159;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1160;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1161;
                this.match(IndexDate.UF);
                this.state = 1162;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1163;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1164;
                this.simple_event_int();
                this.state = 1165;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1167;
                this.match(IndexDate.UF);
                this.state = 1168;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1169;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1170;
                this.simple_event_int();
                this.state = 1171;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1172;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1174;
                this.match(IndexDate.UF);
                this.state = 1175;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1176;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1177;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1178;
                this.match(IndexDate.UF);
                this.state = 1179;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1180;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1181;
                this.simple_event_int();
                this.state = 1182;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1184;
                this.match(IndexDate.UF);
                this.state = 1185;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1186;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1187;
                this.simple_event_int();
                this.state = 1188;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1189;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1191;
                this.match(IndexDate.UF);
                this.state = 1192;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1193;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1194;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1195;
                this.match(IndexDate.UF);
                this.state = 1196;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1197;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1198;
                this.simple_event_int();
                this.state = 1199;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1201;
                this.match(IndexDate.UF);
                this.state = 1202;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1203;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1204;
                this.simple_event_int();
                this.state = 1205;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1206;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1208;
                this.match(IndexDate.RF);
                this.state = 1209;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1210;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1211;
                this.match(IndexDate.RF);
                this.state = 1212;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1213;
                this.provider_error_sub_filter();
                this.state = 1214;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1216;
                this.match(IndexDate.RF);
                this.state = 1217;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1218;
                this.visit_occurrence_error_sub_filter();
                this.state = 1219;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_criteria(): Observation_event_criteriaContext {
        let localContext = new Observation_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 194, IndexDate.RULE_observation_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1223;
            this.observation_event_filter();
            this.state = 1228;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1224;
                this.match(IndexDate.COMMA);
                this.state = 1225;
                this.observation_event_filter();
                }
                }
                this.state = 1230;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_filter(): Observation_event_filterContext {
        let localContext = new Observation_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 196, IndexDate.RULE_observation_event_filter);
        try {
            this.state = 1236;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 56, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1231;
                this.observation_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1232;
                this.observation_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1233;
                this.observation_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1234;
                this.observation_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1235;
                this.observation_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filters(): Observation_concept_filtersContext {
        let localContext = new Observation_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 198, IndexDate.RULE_observation_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1238;
            this.match(IndexDate.CF);
            this.state = 1239;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1242;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 57, this.context) ) {
            case 1:
                {
                this.state = 1240;
                this.observation_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1241;
                this.observation_concept_filter();
                }
                break;
            }
            this.state = 1244;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext {
        let localContext = new Observation_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 200, IndexDate.RULE_observation_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1246;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 165 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1247;
            this.match(IndexDate.IN);
            this.state = 1248;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filter(): Observation_concept_filterContext {
        let localContext = new Observation_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 202, IndexDate.RULE_observation_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1250;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 165 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1251;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1252;
            this.match(IndexDate.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext {
        let localContext = new Observation_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 204, IndexDate.RULE_observation_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1254;
            this.match(IndexDate.NF);
            this.state = 1255;
            this.match(IndexDate.OPEN_PAREN);
            {
            this.state = 1256;
            this.observation_float_filter();
            }
            this.state = 1257;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_float_filter(): Observation_float_filterContext {
        let localContext = new Observation_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 206, IndexDate.RULE_observation_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1259;
            this.match(IndexDate.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
            this.state = 1260;
            this.comparison_op();
            this.state = 1261;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext {
        let localContext = new Observation_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 208, IndexDate.RULE_observation_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1263;
            this.match(IndexDate.UF);
            this.state = 1264;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1265;
            this.observation_uniqueness_filter();
            this.state = 1266;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        let localContext = new Observation_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 210, IndexDate.RULE_observation_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1270;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MINIMUM_BETWEEN:
                {
                this.state = 1268;
                this.simple_uniqueness_filter();
                }
                break;
            case IndexDate.FIXED_WINDOW:
            case IndexDate.ROLLING_WINDOW:
                {
                this.state = 1269;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1272;
            this.match(IndexDate.OBSERVATION_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext {
        let localContext = new Observation_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 212, IndexDate.RULE_observation_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1274;
            this.match(IndexDate.RF);
            this.state = 1275;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1276;
            this.observation_related_entity_filter();
            this.state = 1277;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        let localContext = new Observation_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 214, IndexDate.RULE_observation_related_entity_filter);
        try {
            this.state = 1281;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1279;
                this.provider_sub_filter();
                }
                break;
            case IndexDate.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1280;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_error_filter(): Observation_error_filterContext {
        let localContext = new Observation_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 216, IndexDate.RULE_observation_error_filter);
        let _la: number;
        try {
            this.state = 1394;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 60, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1283;
                this.match(IndexDate.CF);
                this.state = 1284;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1285;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1286;
                this.match(IndexDate.CF);
                this.state = 1287;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1288;
                this.match(IndexDate.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1289;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1290;
                this.match(IndexDate.CF);
                this.state = 1291;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1292;
                this.match(IndexDate.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1293;
                this.match(IndexDate.IN);
                this.state = 1294;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1295;
                this.match(IndexDate.CF);
                this.state = 1296;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1297;
                this.match(IndexDate.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1298;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1299;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1300;
                this.match(IndexDate.CF);
                this.state = 1301;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1302;
                this.match(IndexDate.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1303;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1304;
                this.match(IndexDate.CF);
                this.state = 1305;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1306;
                this.match(IndexDate.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1307;
                this.match(IndexDate.IN);
                this.state = 1308;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1309;
                this.match(IndexDate.CF);
                this.state = 1310;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1311;
                this.match(IndexDate.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1312;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1313;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1314;
                this.match(IndexDate.NF);
                this.state = 1315;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1316;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1317;
                this.match(IndexDate.NF);
                this.state = 1318;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1319;
                this.match(IndexDate.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1320;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1321;
                this.match(IndexDate.NF);
                this.state = 1322;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1323;
                this.match(IndexDate.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1324;
                this.comparison_op();
                this.state = 1325;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1327;
                this.match(IndexDate.UF);
                this.state = 1328;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1329;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1330;
                this.match(IndexDate.UF);
                this.state = 1331;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1332;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1333;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1334;
                this.match(IndexDate.UF);
                this.state = 1335;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1336;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1337;
                this.simple_event_int();
                this.state = 1338;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1340;
                this.match(IndexDate.UF);
                this.state = 1341;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1342;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1343;
                this.simple_event_int();
                this.state = 1344;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1345;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1347;
                this.match(IndexDate.UF);
                this.state = 1348;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1349;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1350;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1351;
                this.match(IndexDate.UF);
                this.state = 1352;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1353;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1354;
                this.simple_event_int();
                this.state = 1355;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1357;
                this.match(IndexDate.UF);
                this.state = 1358;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1359;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1360;
                this.simple_event_int();
                this.state = 1361;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1362;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1364;
                this.match(IndexDate.UF);
                this.state = 1365;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1366;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1367;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1368;
                this.match(IndexDate.UF);
                this.state = 1369;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1370;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1371;
                this.simple_event_int();
                this.state = 1372;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1374;
                this.match(IndexDate.UF);
                this.state = 1375;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1376;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1377;
                this.simple_event_int();
                this.state = 1378;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1379;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1381;
                this.match(IndexDate.RF);
                this.state = 1382;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1383;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1384;
                this.match(IndexDate.RF);
                this.state = 1385;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1386;
                this.provider_error_sub_filter();
                this.state = 1387;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1389;
                this.match(IndexDate.RF);
                this.state = 1390;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1391;
                this.visit_occurrence_error_sub_filter();
                this.state = 1392;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext {
        let localContext = new Procedure_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 218, IndexDate.RULE_procedure_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1396;
            this.procedure_occurrence_event_filter();
            this.state = 1401;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1397;
                this.match(IndexDate.COMMA);
                this.state = 1398;
                this.procedure_occurrence_event_filter();
                }
                }
                this.state = 1403;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext {
        let localContext = new Procedure_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 220, IndexDate.RULE_procedure_occurrence_event_filter);
        try {
            this.state = 1409;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 62, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1404;
                this.procedure_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1405;
                this.procedure_occurrence_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1406;
                this.procedure_occurrence_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1407;
                this.procedure_occurrence_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1408;
                this.procedure_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext {
        let localContext = new Procedure_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 222, IndexDate.RULE_procedure_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1411;
            this.match(IndexDate.CF);
            this.state = 1412;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1415;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 63, this.context) ) {
            case 1:
                {
                this.state = 1413;
                this.procedure_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1414;
                this.procedure_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1417;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext {
        let localContext = new Procedure_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 224, IndexDate.RULE_procedure_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1419;
            this.match(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1420;
            this.match(IndexDate.IN);
            this.state = 1421;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext {
        let localContext = new Procedure_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 226, IndexDate.RULE_procedure_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1423;
            this.match(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1424;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1425;
            this.match(IndexDate.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext {
        let localContext = new Procedure_occurrence_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 228, IndexDate.RULE_procedure_occurrence_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1427;
            this.match(IndexDate.NF);
            this.state = 1428;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1429;
            this.procedure_occurrence_int_filter();
            this.state = 1430;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        let localContext = new Procedure_occurrence_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 230, IndexDate.RULE_procedure_occurrence_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1432;
            this.match(IndexDate.QUANTITY);
            this.state = 1433;
            this.comparison_op();
            this.state = 1434;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext {
        let localContext = new Procedure_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 232, IndexDate.RULE_procedure_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1436;
            this.match(IndexDate.UF);
            this.state = 1437;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1438;
            this.procedure_occurrence_uniqueness_filter();
            this.state = 1439;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        let localContext = new Procedure_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 234, IndexDate.RULE_procedure_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1443;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MINIMUM_BETWEEN:
                {
                this.state = 1441;
                this.simple_uniqueness_filter();
                }
                break;
            case IndexDate.FIXED_WINDOW:
            case IndexDate.ROLLING_WINDOW:
                {
                this.state = 1442;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1445;
            this.match(IndexDate.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext {
        let localContext = new Procedure_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 236, IndexDate.RULE_procedure_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1447;
            this.match(IndexDate.RF);
            this.state = 1448;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1449;
            this.procedure_occurrence_related_entity_filter();
            this.state = 1450;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        let localContext = new Procedure_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 238, IndexDate.RULE_procedure_occurrence_related_entity_filter);
        try {
            this.state = 1454;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1452;
                this.provider_sub_filter();
                }
                break;
            case IndexDate.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1453;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext {
        let localContext = new Procedure_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 240, IndexDate.RULE_procedure_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1553;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 66, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1456;
                this.match(IndexDate.CF);
                this.state = 1457;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1458;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1459;
                this.match(IndexDate.CF);
                this.state = 1460;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1461;
                this.match(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1462;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1463;
                this.match(IndexDate.CF);
                this.state = 1464;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1465;
                this.match(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1466;
                this.match(IndexDate.IN);
                this.state = 1467;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1468;
                this.match(IndexDate.CF);
                this.state = 1469;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1470;
                this.match(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1471;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1472;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1473;
                this.match(IndexDate.NF);
                this.state = 1474;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1475;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1476;
                this.match(IndexDate.NF);
                this.state = 1477;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1478;
                this.match(IndexDate.QUANTITY);
                this.state = 1479;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1480;
                this.match(IndexDate.NF);
                this.state = 1481;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1482;
                this.match(IndexDate.QUANTITY);
                this.state = 1483;
                this.comparison_op();
                this.state = 1484;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1486;
                this.match(IndexDate.UF);
                this.state = 1487;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1488;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1489;
                this.match(IndexDate.UF);
                this.state = 1490;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1491;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1492;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1493;
                this.match(IndexDate.UF);
                this.state = 1494;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1495;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1496;
                this.simple_event_int();
                this.state = 1497;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1499;
                this.match(IndexDate.UF);
                this.state = 1500;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1501;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1502;
                this.simple_event_int();
                this.state = 1503;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1504;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1506;
                this.match(IndexDate.UF);
                this.state = 1507;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1508;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1509;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1510;
                this.match(IndexDate.UF);
                this.state = 1511;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1512;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1513;
                this.simple_event_int();
                this.state = 1514;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1516;
                this.match(IndexDate.UF);
                this.state = 1517;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1518;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1519;
                this.simple_event_int();
                this.state = 1520;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1521;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1523;
                this.match(IndexDate.UF);
                this.state = 1524;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1525;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1526;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1527;
                this.match(IndexDate.UF);
                this.state = 1528;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1529;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1530;
                this.simple_event_int();
                this.state = 1531;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1533;
                this.match(IndexDate.UF);
                this.state = 1534;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1535;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1536;
                this.simple_event_int();
                this.state = 1537;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1538;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1540;
                this.match(IndexDate.RF);
                this.state = 1541;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1542;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1543;
                this.match(IndexDate.RF);
                this.state = 1544;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1545;
                this.provider_error_sub_filter();
                this.state = 1546;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1548;
                this.match(IndexDate.RF);
                this.state = 1549;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1550;
                this.visit_occurrence_error_sub_filter();
                this.state = 1551;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filters(): Provider_concept_filtersContext {
        let localContext = new Provider_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 242, IndexDate.RULE_provider_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1555;
            this.match(IndexDate.CF);
            this.state = 1556;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1559;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 67, this.context) ) {
            case 1:
                {
                this.state = 1557;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1558;
                this.provider_concept_filter();
                }
                break;
            }
            this.state = 1561;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext {
        let localContext = new Provider_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 244, IndexDate.RULE_provider_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1563;
            this.match(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1564;
            this.match(IndexDate.IN);
            this.state = 1565;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filter(): Provider_concept_filterContext {
        let localContext = new Provider_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 246, IndexDate.RULE_provider_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1567;
            this.match(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1568;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1569;
            this.match(IndexDate.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_sub_filter(): Provider_sub_filterContext {
        let localContext = new Provider_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 248, IndexDate.RULE_provider_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1571;
            this.match(IndexDate.PROVIDER);
            this.state = 1574;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 68, this.context) ) {
            case 1:
                {
                this.state = 1572;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1573;
                this.provider_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext {
        let localContext = new Provider_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 250, IndexDate.RULE_provider_error_sub_filter);
        let _la: number;
        try {
            this.state = 1586;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 69, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1577;
                this.match(IndexDate.PROVIDER);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1578;
                this.match(IndexDate.PROVIDER);
                this.state = 1579;
                this.match(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1580;
                this.match(IndexDate.PROVIDER);
                this.state = 1581;
                this.match(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1582;
                this.match(IndexDate.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1583;
                this.match(IndexDate.PROVIDER);
                this.state = 1584;
                this.match(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1585;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext {
        let localContext = new Visit_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 252, IndexDate.RULE_visit_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1588;
            this.visit_occurrence_event_filter();
            this.state = 1593;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1589;
                this.match(IndexDate.COMMA);
                this.state = 1590;
                this.visit_occurrence_event_filter();
                }
                }
                this.state = 1595;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext {
        let localContext = new Visit_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 254, IndexDate.RULE_visit_occurrence_event_filter);
        try {
            this.state = 1600;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 71, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1596;
                this.visit_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1597;
                this.visit_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1598;
                this.visit_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1599;
                this.visit_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext {
        let localContext = new Visit_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 256, IndexDate.RULE_visit_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1602;
            this.match(IndexDate.CF);
            this.state = 1603;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1606;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 72, this.context) ) {
            case 1:
                {
                this.state = 1604;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1605;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1608;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext {
        let localContext = new Visit_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 258, IndexDate.RULE_visit_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1610;
            this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1611;
            this.match(IndexDate.IN);
            this.state = 1612;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext {
        let localContext = new Visit_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 260, IndexDate.RULE_visit_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1614;
            this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1615;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1616;
            this.match(IndexDate.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext {
        let localContext = new Visit_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 262, IndexDate.RULE_visit_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1618;
            this.match(IndexDate.UF);
            this.state = 1619;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1620;
            this.visit_occurrence_uniqueness_filter();
            this.state = 1621;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        let localContext = new Visit_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 264, IndexDate.RULE_visit_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1625;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.MINIMUM_BETWEEN:
                {
                this.state = 1623;
                this.simple_uniqueness_filter();
                }
                break;
            case IndexDate.FIXED_WINDOW:
            case IndexDate.ROLLING_WINDOW:
                {
                this.state = 1624;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1627;
            this.match(IndexDate.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext {
        let localContext = new Visit_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 266, IndexDate.RULE_visit_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1629;
            this.match(IndexDate.RF);
            this.state = 1630;
            this.match(IndexDate.OPEN_PAREN);
            this.state = 1631;
            this.visit_occurrence_related_entity_filter();
            this.state = 1632;
            this.match(IndexDate.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        let localContext = new Visit_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 268, IndexDate.RULE_visit_occurrence_related_entity_filter);
        try {
            this.state = 1636;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1634;
                this.provider_sub_filter();
                }
                break;
            case IndexDate.CONDITION_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1635;
                this.condition_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext {
        let localContext = new Visit_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 270, IndexDate.RULE_visit_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1638;
            this.match(IndexDate.VISIT_OCCURRENCE);
            this.state = 1641;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 75, this.context) ) {
            case 1:
                {
                this.state = 1639;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1640;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext {
        let localContext = new Visit_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 272, IndexDate.RULE_visit_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1653;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 76, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1644;
                this.match(IndexDate.VISIT_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1645;
                this.match(IndexDate.VISIT_OCCURRENCE);
                this.state = 1646;
                this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1647;
                this.match(IndexDate.VISIT_OCCURRENCE);
                this.state = 1648;
                this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1649;
                this.match(IndexDate.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1650;
                this.match(IndexDate.VISIT_OCCURRENCE);
                this.state = 1651;
                this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1652;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext {
        let localContext = new Visit_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 274, IndexDate.RULE_visit_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1739;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 77, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1655;
                this.match(IndexDate.CF);
                this.state = 1656;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1657;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1658;
                this.match(IndexDate.CF);
                this.state = 1659;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1660;
                this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1661;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1662;
                this.match(IndexDate.CF);
                this.state = 1663;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1664;
                this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1665;
                this.match(IndexDate.IN);
                this.state = 1666;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1667;
                this.match(IndexDate.CF);
                this.state = 1668;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1669;
                this.match(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1670;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1671;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1672;
                this.match(IndexDate.UF);
                this.state = 1673;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1674;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1675;
                this.match(IndexDate.UF);
                this.state = 1676;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1677;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1678;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1679;
                this.match(IndexDate.UF);
                this.state = 1680;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1681;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1682;
                this.simple_event_int();
                this.state = 1683;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1685;
                this.match(IndexDate.UF);
                this.state = 1686;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1687;
                this.match(IndexDate.MINIMUM_BETWEEN);
                this.state = 1688;
                this.simple_event_int();
                this.state = 1689;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1690;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1692;
                this.match(IndexDate.UF);
                this.state = 1693;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1694;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1695;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1696;
                this.match(IndexDate.UF);
                this.state = 1697;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1698;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1699;
                this.simple_event_int();
                this.state = 1700;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1702;
                this.match(IndexDate.UF);
                this.state = 1703;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1704;
                this.match(IndexDate.FIXED_WINDOW);
                this.state = 1705;
                this.simple_event_int();
                this.state = 1706;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1707;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1709;
                this.match(IndexDate.UF);
                this.state = 1710;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1711;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1712;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1713;
                this.match(IndexDate.UF);
                this.state = 1714;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1715;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1716;
                this.simple_event_int();
                this.state = 1717;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1719;
                this.match(IndexDate.UF);
                this.state = 1720;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1721;
                this.match(IndexDate.ROLLING_WINDOW);
                this.state = 1722;
                this.simple_event_int();
                this.state = 1723;
                this.match(IndexDate.TIME_UNIT);
                this.state = 1724;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1726;
                this.match(IndexDate.RF);
                this.state = 1727;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1728;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1729;
                this.match(IndexDate.RF);
                this.state = 1730;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1731;
                this.provider_error_sub_filter();
                this.state = 1732;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1734;
                this.match(IndexDate.RF);
                this.state = 1735;
                this.match(IndexDate.OPEN_PAREN);
                this.state = 1736;
                this.condition_occurrence_error_sub_filter();
                this.state = 1737;
                this.match(IndexDate.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public comparison_op(): Comparison_opContext {
        let localContext = new Comparison_opContext(this.context, this.state);
        this.enterRule(localContext, 276, IndexDate.RULE_comparison_op);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1741;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 85)) & ~0x1F) === 0 && ((1 << (_la - 85)) & 1985) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext {
        let localContext = new Simple_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 278, IndexDate.RULE_simple_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1743;
            this.match(IndexDate.MINIMUM_BETWEEN);
            this.state = 1744;
            this.simple_event_int();
            this.state = 1745;
            this.match(IndexDate.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext {
        let localContext = new Simple_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 280, IndexDate.RULE_simple_uniqueness_filter_window);
        try {
            this.state = 1749;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case IndexDate.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1747;
                this.fixed_window_uniqueness_filter();
                }
                break;
            case IndexDate.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1748;
                this.rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext {
        let localContext = new Fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 282, IndexDate.RULE_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1751;
            this.match(IndexDate.FIXED_WINDOW);
            this.state = 1752;
            this.simple_event_int();
            this.state = 1753;
            this.match(IndexDate.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext {
        let localContext = new Rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 284, IndexDate.RULE_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1755;
            this.match(IndexDate.ROLLING_WINDOW);
            this.state = 1756;
            this.simple_event_int();
            this.state = 1757;
            this.match(IndexDate.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_float(): Simple_event_floatContext {
        let localContext = new Simple_event_floatContext(this.context, this.state);
        this.enterRule(localContext, 286, IndexDate.RULE_simple_event_float);
        let _la: number;
        try {
            this.state = 1767;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 81, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1759;
                this.simple_event_int();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1761;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 76) {
                    {
                    this.state = 1760;
                    this.match(IndexDate.INT);
                    }
                }

                this.state = 1763;
                this.match(IndexDate.PERIOD);
                this.state = 1765;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 76) {
                    {
                    this.state = 1764;
                    this.match(IndexDate.INT);
                    }
                }

                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_int(): Simple_event_intContext {
        let localContext = new Simple_event_intContext(this.context, this.state);
        this.enterRule(localContext, 288, IndexDate.RULE_simple_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1769;
            this.match(IndexDate.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        let localContext = new Concept_group_selectionContext(this.context, this.state);
        this.enterRule(localContext, 290, IndexDate.RULE_concept_group_selection);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1771;
            this.match(IndexDate.CONCEPT_GROUP);
            this.state = 1776;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1772;
                this.match(IndexDate.COMMA);
                this.state = 1773;
                this.match(IndexDate.CONCEPT_GROUP);
                }
                }
                this.state = 1778;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,182,1780,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,
        7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,
        13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
        20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,
        26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,
        33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,
        39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,
        46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,
        52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,7,58,2,
        59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,2,65,7,
        65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,7,71,2,
        72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,78,7,
        78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,2,
        85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,
        91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,97,2,
        98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,7,103,
        2,104,7,104,2,105,7,105,2,106,7,106,2,107,7,107,2,108,7,108,2,109,
        7,109,2,110,7,110,2,111,7,111,2,112,7,112,2,113,7,113,2,114,7,114,
        2,115,7,115,2,116,7,116,2,117,7,117,2,118,7,118,2,119,7,119,2,120,
        7,120,2,121,7,121,2,122,7,122,2,123,7,123,2,124,7,124,2,125,7,125,
        2,126,7,126,2,127,7,127,2,128,7,128,2,129,7,129,2,130,7,130,2,131,
        7,131,2,132,7,132,2,133,7,133,2,134,7,134,2,135,7,135,2,136,7,136,
        2,137,7,137,2,138,7,138,2,139,7,139,2,140,7,140,2,141,7,141,2,142,
        7,142,2,143,7,143,2,144,7,144,2,145,7,145,1,0,1,0,1,0,1,0,1,0,1,
        1,1,1,1,1,1,1,3,1,302,8,1,1,2,1,2,1,2,1,2,1,2,1,3,1,3,1,3,1,3,1,
        3,3,3,314,8,3,1,3,1,3,1,4,1,4,3,4,320,8,4,1,4,1,4,1,4,3,4,325,8,
        4,1,5,1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,1,7,1,7,1,7,1,7,1,8,1,
        8,1,8,1,8,1,9,1,9,1,9,1,9,1,10,1,10,1,10,1,10,1,11,1,11,1,11,3,11,
        356,8,11,1,12,1,12,1,12,1,12,1,12,1,12,1,12,3,12,365,8,12,1,12,1,
        12,1,12,1,13,1,13,1,13,4,13,373,8,13,11,13,12,13,374,1,14,1,14,3,
        14,379,8,14,1,15,1,15,3,15,383,8,15,1,16,1,16,1,16,1,16,3,16,389,
        8,16,1,16,1,16,1,17,1,17,1,18,1,18,1,18,1,18,1,18,1,19,1,19,3,19,
        402,8,19,1,19,1,19,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,3,20,460,8,20,1,21,1,21,1,21,1,21,
        1,21,1,21,1,21,1,21,1,22,1,22,1,22,5,22,473,8,22,10,22,12,22,476,
        9,22,1,23,1,23,1,23,1,23,3,23,482,8,23,1,24,1,24,3,24,486,8,24,1,
        25,1,25,1,25,1,25,1,25,1,26,1,26,1,26,1,26,1,27,1,27,1,27,1,27,3,
        27,501,8,27,1,27,1,27,1,28,1,28,3,28,507,8,28,1,28,1,28,1,28,1,29,
        1,29,3,29,514,8,29,1,30,1,30,1,30,1,30,1,30,1,30,1,30,1,30,1,31,
        1,31,1,31,4,31,527,8,31,11,31,12,31,528,1,32,1,32,1,32,1,32,1,32,
        3,32,536,8,32,1,33,1,33,1,33,1,33,3,33,542,8,33,1,33,1,33,1,34,1,
        34,1,34,1,34,3,34,550,8,34,1,34,1,34,1,35,1,35,1,36,1,36,1,36,1,
        36,1,36,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,3,37,570,8,
        37,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,
        38,1,38,1,38,1,38,1,38,1,38,3,38,590,8,38,1,39,1,39,1,39,1,39,1,
        40,1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,40,3,40,608,
        8,40,1,41,1,41,1,41,1,41,1,41,1,41,1,41,1,41,1,41,1,41,1,41,1,41,
        3,41,622,8,41,1,42,1,42,1,42,1,42,1,43,1,43,3,43,630,8,43,1,44,1,
        44,1,44,1,44,1,45,1,45,1,45,1,45,1,46,1,46,1,47,1,47,1,47,1,47,1,
        47,1,47,3,47,648,8,47,1,48,1,48,1,48,1,48,1,48,1,49,1,49,1,49,1,
        49,1,49,1,50,1,50,1,50,1,50,1,50,1,51,1,51,1,51,1,51,1,51,1,52,1,
        52,1,52,1,52,1,52,1,53,1,53,1,53,1,53,1,53,1,54,1,54,1,54,3,54,683,
        8,54,1,54,1,54,1,55,1,55,1,55,3,55,690,8,55,1,55,1,55,1,56,1,56,
        1,56,3,56,697,8,56,1,56,1,56,1,57,1,57,1,57,3,57,704,8,57,1,57,1,
        57,1,58,1,58,1,58,3,58,711,8,58,1,58,1,58,1,59,1,59,1,59,3,59,718,
        8,59,1,59,1,59,1,60,1,60,1,60,5,60,725,8,60,10,60,12,60,728,9,60,
        1,61,1,61,1,61,1,61,3,61,734,8,61,1,62,1,62,1,62,1,62,3,62,740,8,
        62,1,62,1,62,1,63,1,63,1,63,1,63,1,64,1,64,1,64,1,64,1,65,1,65,1,
        65,1,65,1,65,1,66,1,66,3,66,759,8,66,1,66,1,66,1,67,1,67,1,67,1,
        67,1,67,1,68,1,68,3,68,770,8,68,1,69,1,69,1,69,3,69,775,8,69,1,70,
        1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,3,70,787,8,70,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,3,71,873,8,71,1,72,1,72,1,72,5,72,878,8,
        72,10,72,12,72,881,9,72,1,73,1,73,1,73,1,73,1,73,3,73,888,8,73,1,
        74,1,74,1,74,1,74,3,74,894,8,74,1,74,1,74,1,75,1,75,1,75,1,75,1,
        76,1,76,1,76,1,76,1,77,1,77,1,77,1,77,3,77,910,8,77,1,77,1,77,1,
        78,1,78,1,78,1,78,1,79,1,79,1,79,1,79,1,80,1,80,1,80,1,80,1,80,1,
        81,1,81,3,81,929,8,81,1,81,1,81,1,82,1,82,1,82,1,82,1,82,1,83,1,
        83,3,83,940,8,83,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,
        84,1,84,1,84,1,84,1,84,1,84,1,84,3,84,1049,8,84,1,85,1,85,1,85,5,
        85,1054,8,85,10,85,12,85,1057,9,85,1,86,1,86,1,86,1,86,1,86,3,86,
        1064,8,86,1,87,1,87,1,87,1,87,3,87,1070,8,87,1,87,1,87,1,88,1,88,
        1,88,1,88,1,89,1,89,1,89,1,89,1,90,1,90,1,90,1,90,1,90,1,91,1,91,
        1,91,1,91,1,92,1,92,1,92,1,92,1,92,1,93,1,93,3,93,1098,8,93,1,93,
        1,93,1,94,1,94,1,94,1,94,1,94,1,95,1,95,3,95,1109,8,95,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,
        1,96,1,96,1,96,1,96,1,96,3,96,1222,8,96,1,97,1,97,1,97,5,97,1227,
        8,97,10,97,12,97,1230,9,97,1,98,1,98,1,98,1,98,1,98,3,98,1237,8,
        98,1,99,1,99,1,99,1,99,3,99,1243,8,99,1,99,1,99,1,100,1,100,1,100,
        1,100,1,101,1,101,1,101,1,101,1,102,1,102,1,102,1,102,1,102,1,103,
        1,103,1,103,1,103,1,104,1,104,1,104,1,104,1,104,1,105,1,105,3,105,
        1271,8,105,1,105,1,105,1,106,1,106,1,106,1,106,1,106,1,107,1,107,
        3,107,1282,8,107,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,1,108,
        1,108,1,108,1,108,1,108,3,108,1395,8,108,1,109,1,109,1,109,5,109,
        1400,8,109,10,109,12,109,1403,9,109,1,110,1,110,1,110,1,110,1,110,
        3,110,1410,8,110,1,111,1,111,1,111,1,111,3,111,1416,8,111,1,111,
        1,111,1,112,1,112,1,112,1,112,1,113,1,113,1,113,1,113,1,114,1,114,
        1,114,1,114,1,114,1,115,1,115,1,115,1,115,1,116,1,116,1,116,1,116,
        1,116,1,117,1,117,3,117,1444,8,117,1,117,1,117,1,118,1,118,1,118,
        1,118,1,118,1,119,1,119,3,119,1455,8,119,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,3,120,1554,8,120,1,121,1,121,1,121,
        1,121,3,121,1560,8,121,1,121,1,121,1,122,1,122,1,122,1,122,1,123,
        1,123,1,123,1,123,1,124,1,124,1,124,3,124,1575,8,124,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,3,125,1587,8,125,
        1,126,1,126,1,126,5,126,1592,8,126,10,126,12,126,1595,9,126,1,127,
        1,127,1,127,1,127,3,127,1601,8,127,1,128,1,128,1,128,1,128,3,128,
        1607,8,128,1,128,1,128,1,129,1,129,1,129,1,129,1,130,1,130,1,130,
        1,130,1,131,1,131,1,131,1,131,1,131,1,132,1,132,3,132,1626,8,132,
        1,132,1,132,1,133,1,133,1,133,1,133,1,133,1,134,1,134,3,134,1637,
        8,134,1,135,1,135,1,135,3,135,1642,8,135,1,136,1,136,1,136,1,136,
        1,136,1,136,1,136,1,136,1,136,1,136,3,136,1654,8,136,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,3,137,1740,8,137,1,138,1,138,1,139,
        1,139,1,139,1,139,1,140,1,140,3,140,1750,8,140,1,141,1,141,1,141,
        1,141,1,142,1,142,1,142,1,142,1,143,1,143,3,143,1762,8,143,1,143,
        1,143,3,143,1766,8,143,3,143,1768,8,143,1,144,1,144,1,145,1,145,
        1,145,5,145,1775,8,145,10,145,12,145,1778,9,145,1,145,0,0,146,0,
        2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,46,
        48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,
        92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,
        126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156,
        158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,
        190,192,194,196,198,200,202,204,206,208,210,212,214,216,218,220,
        222,224,226,228,230,232,234,236,238,240,242,244,246,248,250,252,
        254,256,258,260,262,264,266,268,270,272,274,276,278,280,282,284,
        286,288,290,0,9,2,0,60,60,156,156,1,0,116,118,1,0,96,97,3,0,30,33,
        35,35,37,38,2,0,85,85,91,91,2,0,164,164,170,170,2,0,158,158,160,
        160,2,0,165,165,170,170,2,0,85,85,91,95,1877,0,292,1,0,0,0,2,301,
        1,0,0,0,4,303,1,0,0,0,6,308,1,0,0,0,8,319,1,0,0,0,10,326,1,0,0,0,
        12,331,1,0,0,0,14,336,1,0,0,0,16,340,1,0,0,0,18,344,1,0,0,0,20,348,
        1,0,0,0,22,355,1,0,0,0,24,357,1,0,0,0,26,369,1,0,0,0,28,378,1,0,
        0,0,30,382,1,0,0,0,32,384,1,0,0,0,34,392,1,0,0,0,36,394,1,0,0,0,
        38,401,1,0,0,0,40,459,1,0,0,0,42,461,1,0,0,0,44,469,1,0,0,0,46,481,
        1,0,0,0,48,485,1,0,0,0,50,487,1,0,0,0,52,492,1,0,0,0,54,496,1,0,
        0,0,56,506,1,0,0,0,58,513,1,0,0,0,60,515,1,0,0,0,62,523,1,0,0,0,
        64,535,1,0,0,0,66,537,1,0,0,0,68,545,1,0,0,0,70,553,1,0,0,0,72,555,
        1,0,0,0,74,569,1,0,0,0,76,589,1,0,0,0,78,591,1,0,0,0,80,607,1,0,
        0,0,82,621,1,0,0,0,84,623,1,0,0,0,86,629,1,0,0,0,88,631,1,0,0,0,
        90,635,1,0,0,0,92,639,1,0,0,0,94,647,1,0,0,0,96,649,1,0,0,0,98,654,
        1,0,0,0,100,659,1,0,0,0,102,664,1,0,0,0,104,669,1,0,0,0,106,674,
        1,0,0,0,108,679,1,0,0,0,110,686,1,0,0,0,112,693,1,0,0,0,114,700,
        1,0,0,0,116,707,1,0,0,0,118,714,1,0,0,0,120,721,1,0,0,0,122,733,
        1,0,0,0,124,735,1,0,0,0,126,743,1,0,0,0,128,747,1,0,0,0,130,751,
        1,0,0,0,132,758,1,0,0,0,134,762,1,0,0,0,136,769,1,0,0,0,138,771,
        1,0,0,0,140,786,1,0,0,0,142,872,1,0,0,0,144,874,1,0,0,0,146,887,
        1,0,0,0,148,889,1,0,0,0,150,897,1,0,0,0,152,901,1,0,0,0,154,905,
        1,0,0,0,156,913,1,0,0,0,158,917,1,0,0,0,160,921,1,0,0,0,162,928,
        1,0,0,0,164,932,1,0,0,0,166,939,1,0,0,0,168,1048,1,0,0,0,170,1050,
        1,0,0,0,172,1063,1,0,0,0,174,1065,1,0,0,0,176,1073,1,0,0,0,178,1077,
        1,0,0,0,180,1081,1,0,0,0,182,1086,1,0,0,0,184,1090,1,0,0,0,186,1097,
        1,0,0,0,188,1101,1,0,0,0,190,1108,1,0,0,0,192,1221,1,0,0,0,194,1223,
        1,0,0,0,196,1236,1,0,0,0,198,1238,1,0,0,0,200,1246,1,0,0,0,202,1250,
        1,0,0,0,204,1254,1,0,0,0,206,1259,1,0,0,0,208,1263,1,0,0,0,210,1270,
        1,0,0,0,212,1274,1,0,0,0,214,1281,1,0,0,0,216,1394,1,0,0,0,218,1396,
        1,0,0,0,220,1409,1,0,0,0,222,1411,1,0,0,0,224,1419,1,0,0,0,226,1423,
        1,0,0,0,228,1427,1,0,0,0,230,1432,1,0,0,0,232,1436,1,0,0,0,234,1443,
        1,0,0,0,236,1447,1,0,0,0,238,1454,1,0,0,0,240,1553,1,0,0,0,242,1555,
        1,0,0,0,244,1563,1,0,0,0,246,1567,1,0,0,0,248,1571,1,0,0,0,250,1586,
        1,0,0,0,252,1588,1,0,0,0,254,1600,1,0,0,0,256,1602,1,0,0,0,258,1610,
        1,0,0,0,260,1614,1,0,0,0,262,1618,1,0,0,0,264,1625,1,0,0,0,266,1629,
        1,0,0,0,268,1636,1,0,0,0,270,1638,1,0,0,0,272,1653,1,0,0,0,274,1739,
        1,0,0,0,276,1741,1,0,0,0,278,1743,1,0,0,0,280,1749,1,0,0,0,282,1751,
        1,0,0,0,284,1755,1,0,0,0,286,1767,1,0,0,0,288,1769,1,0,0,0,290,1771,
        1,0,0,0,292,293,5,1,0,0,293,294,5,85,0,0,294,295,3,2,1,0,295,296,
        5,83,0,0,296,1,1,0,0,0,297,302,3,4,2,0,298,302,3,14,7,0,299,302,
        3,6,3,0,300,302,3,16,8,0,301,297,1,0,0,0,301,298,1,0,0,0,301,299,
        1,0,0,0,301,300,1,0,0,0,302,3,1,0,0,0,303,304,5,3,0,0,304,305,5,
        81,0,0,305,306,5,80,0,0,306,307,5,82,0,0,307,5,1,0,0,0,308,309,5,
        2,0,0,309,310,5,81,0,0,310,313,7,0,0,0,311,312,5,84,0,0,312,314,
        3,8,4,0,313,311,1,0,0,0,313,314,1,0,0,0,314,315,1,0,0,0,315,316,
        5,82,0,0,316,7,1,0,0,0,317,320,3,12,6,0,318,320,3,18,9,0,319,317,
        1,0,0,0,319,318,1,0,0,0,320,321,1,0,0,0,321,324,5,84,0,0,322,325,
        3,10,5,0,323,325,3,20,10,0,324,322,1,0,0,0,324,323,1,0,0,0,325,9,
        1,0,0,0,326,327,5,4,0,0,327,328,5,81,0,0,328,329,5,80,0,0,329,330,
        5,82,0,0,330,11,1,0,0,0,331,332,5,5,0,0,332,333,5,81,0,0,333,334,
        5,80,0,0,334,335,5,82,0,0,335,13,1,0,0,0,336,337,5,3,0,0,337,338,
        5,81,0,0,338,339,5,82,0,0,339,15,1,0,0,0,340,341,5,2,0,0,341,342,
        5,81,0,0,342,343,5,82,0,0,343,17,1,0,0,0,344,345,5,5,0,0,345,346,
        5,81,0,0,346,347,5,82,0,0,347,19,1,0,0,0,348,349,5,4,0,0,349,350,
        5,81,0,0,350,351,5,82,0,0,351,21,1,0,0,0,352,356,3,24,12,0,353,356,
        3,42,21,0,354,356,3,60,30,0,355,352,1,0,0,0,355,353,1,0,0,0,355,
        354,1,0,0,0,356,23,1,0,0,0,357,358,5,58,0,0,358,359,5,85,0,0,359,
        360,5,71,0,0,360,361,5,81,0,0,361,364,3,26,13,0,362,363,5,84,0,0,
        363,365,3,30,15,0,364,362,1,0,0,0,364,365,1,0,0,0,365,366,1,0,0,
        0,366,367,5,82,0,0,367,368,5,83,0,0,368,25,1,0,0,0,369,372,3,28,
        14,0,370,371,5,84,0,0,371,373,3,28,14,0,372,370,1,0,0,0,373,374,
        1,0,0,0,374,372,1,0,0,0,374,375,1,0,0,0,375,27,1,0,0,0,376,379,3,
        32,16,0,377,379,3,82,41,0,378,376,1,0,0,0,378,377,1,0,0,0,379,29,
        1,0,0,0,380,383,3,34,17,0,381,383,3,40,20,0,382,380,1,0,0,0,382,
        381,1,0,0,0,383,31,1,0,0,0,384,385,5,74,0,0,385,388,5,81,0,0,386,
        389,3,76,38,0,387,389,3,78,39,0,388,386,1,0,0,0,388,387,1,0,0,0,
        389,390,1,0,0,0,390,391,5,82,0,0,391,33,1,0,0,0,392,393,3,36,18,
        0,393,35,1,0,0,0,394,395,5,23,0,0,395,396,5,81,0,0,396,397,3,38,
        19,0,397,398,5,82,0,0,398,37,1,0,0,0,399,402,3,84,42,0,400,402,3,
        86,43,0,401,399,1,0,0,0,401,400,1,0,0,0,402,403,1,0,0,0,403,404,
        5,6,0,0,404,39,1,0,0,0,405,406,5,23,0,0,406,407,5,81,0,0,407,460,
        5,82,0,0,408,409,5,23,0,0,409,410,5,81,0,0,410,411,5,116,0,0,411,
        460,5,82,0,0,412,413,5,23,0,0,413,414,5,81,0,0,414,415,5,116,0,0,
        415,416,3,92,46,0,416,417,5,82,0,0,417,460,1,0,0,0,418,419,5,23,
        0,0,419,420,5,81,0,0,420,421,5,116,0,0,421,422,3,92,46,0,422,423,
        5,111,0,0,423,424,5,82,0,0,424,460,1,0,0,0,425,426,5,23,0,0,426,
        427,5,81,0,0,427,428,5,119,0,0,428,460,5,82,0,0,429,430,5,23,0,0,
        430,431,5,81,0,0,431,432,5,119,0,0,432,433,3,92,46,0,433,434,5,82,
        0,0,434,460,1,0,0,0,435,436,5,23,0,0,436,437,5,81,0,0,437,438,5,
        119,0,0,438,439,3,92,46,0,439,440,5,111,0,0,440,441,5,82,0,0,441,
        460,1,0,0,0,442,443,5,23,0,0,443,444,5,81,0,0,444,445,5,120,0,0,
        445,460,5,82,0,0,446,447,5,23,0,0,447,448,5,81,0,0,448,449,5,120,
        0,0,449,450,3,92,46,0,450,451,5,82,0,0,451,460,1,0,0,0,452,453,5,
        23,0,0,453,454,5,81,0,0,454,455,5,120,0,0,455,456,3,92,46,0,456,
        457,5,111,0,0,457,458,5,82,0,0,458,460,1,0,0,0,459,405,1,0,0,0,459,
        408,1,0,0,0,459,412,1,0,0,0,459,418,1,0,0,0,459,425,1,0,0,0,459,
        429,1,0,0,0,459,435,1,0,0,0,459,442,1,0,0,0,459,446,1,0,0,0,459,
        452,1,0,0,0,460,41,1,0,0,0,461,462,5,59,0,0,462,463,5,85,0,0,463,
        464,5,72,0,0,464,465,5,81,0,0,465,466,3,44,22,0,466,467,5,82,0,0,
        467,468,5,83,0,0,468,43,1,0,0,0,469,474,3,46,23,0,470,471,5,84,0,
        0,471,473,3,46,23,0,472,470,1,0,0,0,473,476,1,0,0,0,474,472,1,0,
        0,0,474,475,1,0,0,0,475,45,1,0,0,0,476,474,1,0,0,0,477,482,3,48,
        24,0,478,482,3,54,27,0,479,482,3,80,40,0,480,482,3,82,41,0,481,477,
        1,0,0,0,481,478,1,0,0,0,481,479,1,0,0,0,481,480,1,0,0,0,482,47,1,
        0,0,0,483,486,5,8,0,0,484,486,3,50,25,0,485,483,1,0,0,0,485,484,
        1,0,0,0,486,49,1,0,0,0,487,488,5,10,0,0,488,489,5,81,0,0,489,490,
        3,52,26,0,490,491,5,82,0,0,491,51,1,0,0,0,492,493,7,1,0,0,493,494,
        5,76,0,0,494,495,5,111,0,0,495,53,1,0,0,0,496,497,5,74,0,0,497,500,
        5,81,0,0,498,501,3,56,28,0,499,501,3,58,29,0,500,498,1,0,0,0,500,
        499,1,0,0,0,501,502,1,0,0,0,502,503,5,82,0,0,503,55,1,0,0,0,504,
        507,3,76,38,0,505,507,3,78,39,0,506,504,1,0,0,0,506,505,1,0,0,0,
        507,508,1,0,0,0,508,509,5,84,0,0,509,510,5,9,0,0,510,57,1,0,0,0,
        511,514,3,76,38,0,512,514,3,78,39,0,513,511,1,0,0,0,513,512,1,0,
        0,0,514,59,1,0,0,0,515,516,5,60,0,0,516,517,5,85,0,0,517,518,5,73,
        0,0,518,519,5,81,0,0,519,520,3,62,31,0,520,521,5,82,0,0,521,522,
        5,83,0,0,522,61,1,0,0,0,523,526,3,64,32,0,524,525,5,84,0,0,525,527,
        3,64,32,0,526,524,1,0,0,0,527,528,1,0,0,0,528,526,1,0,0,0,528,529,
        1,0,0,0,529,63,1,0,0,0,530,536,1,0,0,0,531,536,3,66,33,0,532,536,
        3,82,41,0,533,536,3,68,34,0,534,536,3,74,37,0,535,530,1,0,0,0,535,
        531,1,0,0,0,535,532,1,0,0,0,535,533,1,0,0,0,535,534,1,0,0,0,536,
        65,1,0,0,0,537,538,5,74,0,0,538,541,5,81,0,0,539,542,3,76,38,0,540,
        542,3,78,39,0,541,539,1,0,0,0,541,540,1,0,0,0,542,543,1,0,0,0,543,
        544,5,82,0,0,544,67,1,0,0,0,545,546,5,13,0,0,546,549,5,81,0,0,547,
        550,3,70,35,0,548,550,3,72,36,0,549,547,1,0,0,0,549,548,1,0,0,0,
        550,551,1,0,0,0,551,552,5,82,0,0,552,69,1,0,0,0,553,554,7,2,0,0,
        554,71,1,0,0,0,555,556,5,110,0,0,556,557,5,81,0,0,557,558,5,76,0,
        0,558,559,5,82,0,0,559,73,1,0,0,0,560,561,5,13,0,0,561,562,5,81,
        0,0,562,570,5,82,0,0,563,564,5,13,0,0,564,565,5,81,0,0,565,566,5,
        110,0,0,566,567,5,81,0,0,567,568,5,82,0,0,568,570,5,82,0,0,569,560,
        1,0,0,0,569,563,1,0,0,0,570,75,1,0,0,0,571,572,5,30,0,0,572,573,
        5,121,0,0,573,590,5,150,0,0,574,575,5,31,0,0,575,576,5,121,0,0,576,
        590,5,151,0,0,577,578,5,32,0,0,578,579,5,121,0,0,579,590,5,152,0,
        0,580,581,5,33,0,0,581,582,5,121,0,0,582,590,5,153,0,0,583,584,5,
        35,0,0,584,585,5,121,0,0,585,590,5,154,0,0,586,587,5,37,0,0,587,
        588,5,121,0,0,588,590,5,155,0,0,589,571,1,0,0,0,589,574,1,0,0,0,
        589,577,1,0,0,0,589,580,1,0,0,0,589,583,1,0,0,0,589,586,1,0,0,0,
        590,77,1,0,0,0,591,592,5,38,0,0,592,593,5,121,0,0,593,594,5,6,0,
        0,594,79,1,0,0,0,595,596,5,10,0,0,596,597,5,81,0,0,597,608,5,82,
        0,0,598,599,5,10,0,0,599,600,5,81,0,0,600,601,7,1,0,0,601,608,5,
        82,0,0,602,603,5,10,0,0,603,604,5,81,0,0,604,605,7,1,0,0,605,606,
        5,76,0,0,606,608,5,82,0,0,607,595,1,0,0,0,607,598,1,0,0,0,607,602,
        1,0,0,0,608,81,1,0,0,0,609,610,5,74,0,0,610,611,5,81,0,0,611,622,
        5,82,0,0,612,613,5,74,0,0,613,614,5,81,0,0,614,615,7,3,0,0,615,622,
        5,82,0,0,616,617,5,74,0,0,617,618,5,81,0,0,618,619,7,3,0,0,619,620,
        5,121,0,0,620,622,5,82,0,0,621,609,1,0,0,0,621,612,1,0,0,0,621,616,
        1,0,0,0,622,83,1,0,0,0,623,624,5,116,0,0,624,625,3,92,46,0,625,626,
        5,111,0,0,626,85,1,0,0,0,627,630,3,88,44,0,628,630,3,90,45,0,629,
        627,1,0,0,0,629,628,1,0,0,0,630,87,1,0,0,0,631,632,5,119,0,0,632,
        633,3,92,46,0,633,634,5,111,0,0,634,89,1,0,0,0,635,636,5,120,0,0,
        636,637,3,92,46,0,637,638,5,111,0,0,638,91,1,0,0,0,639,640,5,76,
        0,0,640,93,1,0,0,0,641,648,3,96,48,0,642,648,3,98,49,0,643,648,3,
        100,50,0,644,648,3,102,51,0,645,648,3,104,52,0,646,648,3,106,53,
        0,647,641,1,0,0,0,647,642,1,0,0,0,647,643,1,0,0,0,647,644,1,0,0,
        0,647,645,1,0,0,0,647,646,1,0,0,0,648,95,1,0,0,0,649,650,5,50,0,
        0,650,651,5,85,0,0,651,652,3,108,54,0,652,653,5,83,0,0,653,97,1,
        0,0,0,654,655,5,51,0,0,655,656,5,85,0,0,656,657,3,110,55,0,657,658,
        5,83,0,0,658,99,1,0,0,0,659,660,5,52,0,0,660,661,5,85,0,0,661,662,
        3,112,56,0,662,663,5,83,0,0,663,101,1,0,0,0,664,665,5,53,0,0,665,
        666,5,85,0,0,666,667,3,114,57,0,667,668,5,83,0,0,668,103,1,0,0,0,
        669,670,5,55,0,0,670,671,5,85,0,0,671,672,3,116,58,0,672,673,5,83,
        0,0,673,105,1,0,0,0,674,675,5,57,0,0,675,676,5,85,0,0,676,677,3,
        118,59,0,677,678,5,83,0,0,678,107,1,0,0,0,679,680,5,124,0,0,680,
        682,5,81,0,0,681,683,3,120,60,0,682,681,1,0,0,0,682,683,1,0,0,0,
        683,684,1,0,0,0,684,685,5,82,0,0,685,109,1,0,0,0,686,687,5,125,0,
        0,687,689,5,81,0,0,688,690,3,144,72,0,689,688,1,0,0,0,689,690,1,
        0,0,0,690,691,1,0,0,0,691,692,5,82,0,0,692,111,1,0,0,0,693,694,5,
        126,0,0,694,696,5,81,0,0,695,697,3,170,85,0,696,695,1,0,0,0,696,
        697,1,0,0,0,697,698,1,0,0,0,698,699,5,82,0,0,699,113,1,0,0,0,700,
        701,5,127,0,0,701,703,5,81,0,0,702,704,3,194,97,0,703,702,1,0,0,
        0,703,704,1,0,0,0,704,705,1,0,0,0,705,706,5,82,0,0,706,115,1,0,0,
        0,707,708,5,129,0,0,708,710,5,81,0,0,709,711,3,218,109,0,710,709,
        1,0,0,0,710,711,1,0,0,0,711,712,1,0,0,0,712,713,5,82,0,0,713,117,
        1,0,0,0,714,715,5,131,0,0,715,717,5,81,0,0,716,718,3,252,126,0,717,
        716,1,0,0,0,717,718,1,0,0,0,718,719,1,0,0,0,719,720,5,82,0,0,720,
        119,1,0,0,0,721,726,3,122,61,0,722,723,5,84,0,0,723,725,3,122,61,
        0,724,722,1,0,0,0,725,728,1,0,0,0,726,724,1,0,0,0,726,727,1,0,0,
        0,727,121,1,0,0,0,728,726,1,0,0,0,729,734,3,124,62,0,730,734,3,130,
        65,0,731,734,3,134,67,0,732,734,3,142,71,0,733,729,1,0,0,0,733,730,
        1,0,0,0,733,731,1,0,0,0,733,732,1,0,0,0,734,123,1,0,0,0,735,736,
        5,14,0,0,736,739,5,81,0,0,737,740,3,126,63,0,738,740,3,128,64,0,
        739,737,1,0,0,0,739,738,1,0,0,0,740,741,1,0,0,0,741,742,5,82,0,0,
        742,125,1,0,0,0,743,744,5,162,0,0,744,745,5,102,0,0,745,746,3,290,
        145,0,746,127,1,0,0,0,747,748,5,162,0,0,748,749,7,4,0,0,749,750,
        5,64,0,0,750,129,1,0,0,0,751,752,5,23,0,0,752,753,5,81,0,0,753,754,
        3,132,66,0,754,755,5,82,0,0,755,131,1,0,0,0,756,759,3,278,139,0,
        757,759,3,280,140,0,758,756,1,0,0,0,758,757,1,0,0,0,759,760,1,0,
        0,0,760,761,5,150,0,0,761,133,1,0,0,0,762,763,5,26,0,0,763,764,5,
        81,0,0,764,765,3,136,68,0,765,766,5,82,0,0,766,135,1,0,0,0,767,770,
        3,248,124,0,768,770,3,270,135,0,769,767,1,0,0,0,769,768,1,0,0,0,
        770,137,1,0,0,0,771,774,5,124,0,0,772,775,3,126,63,0,773,775,3,128,
        64,0,774,772,1,0,0,0,774,773,1,0,0,0,775,139,1,0,0,0,776,787,1,0,
        0,0,777,787,5,124,0,0,778,779,5,124,0,0,779,787,5,162,0,0,780,781,
        5,124,0,0,781,782,5,162,0,0,782,787,5,102,0,0,783,784,5,124,0,0,
        784,785,5,162,0,0,785,787,7,4,0,0,786,776,1,0,0,0,786,777,1,0,0,
        0,786,778,1,0,0,0,786,780,1,0,0,0,786,783,1,0,0,0,787,141,1,0,0,
        0,788,789,5,14,0,0,789,790,5,81,0,0,790,873,5,82,0,0,791,792,5,14,
        0,0,792,793,5,81,0,0,793,794,5,162,0,0,794,873,5,82,0,0,795,796,
        5,14,0,0,796,797,5,81,0,0,797,798,5,162,0,0,798,799,5,102,0,0,799,
        873,5,82,0,0,800,801,5,14,0,0,801,802,5,81,0,0,802,803,5,162,0,0,
        803,804,7,4,0,0,804,873,5,82,0,0,805,806,5,23,0,0,806,807,5,81,0,
        0,807,873,5,82,0,0,808,809,5,23,0,0,809,810,5,81,0,0,810,811,5,116,
        0,0,811,873,5,82,0,0,812,813,5,23,0,0,813,814,5,81,0,0,814,815,5,
        116,0,0,815,816,3,288,144,0,816,817,5,82,0,0,817,873,1,0,0,0,818,
        819,5,23,0,0,819,820,5,81,0,0,820,821,5,116,0,0,821,822,3,288,144,
        0,822,823,5,111,0,0,823,824,5,82,0,0,824,873,1,0,0,0,825,826,5,23,
        0,0,826,827,5,81,0,0,827,828,5,119,0,0,828,873,5,82,0,0,829,830,
        5,23,0,0,830,831,5,81,0,0,831,832,5,119,0,0,832,833,3,288,144,0,
        833,834,5,82,0,0,834,873,1,0,0,0,835,836,5,23,0,0,836,837,5,81,0,
        0,837,838,5,119,0,0,838,839,3,288,144,0,839,840,5,111,0,0,840,841,
        5,82,0,0,841,873,1,0,0,0,842,843,5,23,0,0,843,844,5,81,0,0,844,845,
        5,120,0,0,845,873,5,82,0,0,846,847,5,23,0,0,847,848,5,81,0,0,848,
        849,5,120,0,0,849,850,3,288,144,0,850,851,5,82,0,0,851,873,1,0,0,
        0,852,853,5,23,0,0,853,854,5,81,0,0,854,855,5,120,0,0,855,856,3,
        288,144,0,856,857,5,111,0,0,857,858,5,82,0,0,858,873,1,0,0,0,859,
        860,5,26,0,0,860,861,5,81,0,0,861,873,5,82,0,0,862,863,5,26,0,0,
        863,864,5,81,0,0,864,865,3,250,125,0,865,866,5,82,0,0,866,873,1,
        0,0,0,867,868,5,26,0,0,868,869,5,81,0,0,869,870,3,272,136,0,870,
        871,5,82,0,0,871,873,1,0,0,0,872,788,1,0,0,0,872,791,1,0,0,0,872,
        795,1,0,0,0,872,800,1,0,0,0,872,805,1,0,0,0,872,808,1,0,0,0,872,
        812,1,0,0,0,872,818,1,0,0,0,872,825,1,0,0,0,872,829,1,0,0,0,872,
        835,1,0,0,0,872,842,1,0,0,0,872,846,1,0,0,0,872,852,1,0,0,0,872,
        859,1,0,0,0,872,862,1,0,0,0,872,867,1,0,0,0,873,143,1,0,0,0,874,
        879,3,146,73,0,875,876,5,84,0,0,876,878,3,146,73,0,877,875,1,0,0,
        0,878,881,1,0,0,0,879,877,1,0,0,0,879,880,1,0,0,0,880,145,1,0,0,
        0,881,879,1,0,0,0,882,888,3,148,74,0,883,888,3,154,77,0,884,888,
        3,160,80,0,885,888,3,164,82,0,886,888,3,168,84,0,887,882,1,0,0,0,
        887,883,1,0,0,0,887,884,1,0,0,0,887,885,1,0,0,0,887,886,1,0,0,0,
        888,147,1,0,0,0,889,890,5,14,0,0,890,893,5,81,0,0,891,894,3,150,
        75,0,892,894,3,152,76,0,893,891,1,0,0,0,893,892,1,0,0,0,894,895,
        1,0,0,0,895,896,5,82,0,0,896,149,1,0,0,0,897,898,5,163,0,0,898,899,
        5,102,0,0,899,900,3,290,145,0,900,151,1,0,0,0,901,902,5,163,0,0,
        902,903,7,4,0,0,903,904,5,64,0,0,904,153,1,0,0,0,905,906,5,17,0,
        0,906,909,5,81,0,0,907,910,3,156,78,0,908,910,3,158,79,0,909,907,
        1,0,0,0,909,908,1,0,0,0,910,911,1,0,0,0,911,912,5,82,0,0,912,155,
        1,0,0,0,913,914,5,161,0,0,914,915,3,276,138,0,915,916,3,286,143,
        0,916,157,1,0,0,0,917,918,5,157,0,0,918,919,3,276,138,0,919,920,
        3,288,144,0,920,159,1,0,0,0,921,922,5,23,0,0,922,923,5,81,0,0,923,
        924,3,162,81,0,924,925,5,82,0,0,925,161,1,0,0,0,926,929,3,278,139,
        0,927,929,3,280,140,0,928,926,1,0,0,0,928,927,1,0,0,0,929,930,1,
        0,0,0,930,931,5,151,0,0,931,163,1,0,0,0,932,933,5,26,0,0,933,934,
        5,81,0,0,934,935,3,166,83,0,935,936,5,82,0,0,936,165,1,0,0,0,937,
        940,3,248,124,0,938,940,3,270,135,0,939,937,1,0,0,0,939,938,1,0,
        0,0,940,167,1,0,0,0,941,942,5,14,0,0,942,943,5,81,0,0,943,1049,5,
        82,0,0,944,945,5,14,0,0,945,946,5,81,0,0,946,947,5,163,0,0,947,1049,
        5,82,0,0,948,949,5,14,0,0,949,950,5,81,0,0,950,951,5,163,0,0,951,
        952,5,102,0,0,952,1049,5,82,0,0,953,954,5,14,0,0,954,955,5,81,0,
        0,955,956,5,163,0,0,956,957,7,4,0,0,957,1049,5,82,0,0,958,959,5,
        17,0,0,959,960,5,81,0,0,960,1049,5,82,0,0,961,962,5,17,0,0,962,963,
        5,81,0,0,963,964,5,161,0,0,964,1049,5,82,0,0,965,966,5,17,0,0,966,
        967,5,81,0,0,967,968,5,161,0,0,968,969,3,276,138,0,969,970,5,82,
        0,0,970,1049,1,0,0,0,971,972,5,17,0,0,972,973,5,81,0,0,973,974,5,
        157,0,0,974,1049,5,82,0,0,975,976,5,17,0,0,976,977,5,81,0,0,977,
        978,5,157,0,0,978,979,3,276,138,0,979,980,5,82,0,0,980,1049,1,0,
        0,0,981,982,5,23,0,0,982,983,5,81,0,0,983,1049,5,82,0,0,984,985,
        5,23,0,0,985,986,5,81,0,0,986,987,5,116,0,0,987,1049,5,82,0,0,988,
        989,5,23,0,0,989,990,5,81,0,0,990,991,5,116,0,0,991,992,3,288,144,
        0,992,993,5,82,0,0,993,1049,1,0,0,0,994,995,5,23,0,0,995,996,5,81,
        0,0,996,997,5,116,0,0,997,998,3,288,144,0,998,999,5,111,0,0,999,
        1000,5,82,0,0,1000,1049,1,0,0,0,1001,1002,5,23,0,0,1002,1003,5,81,
        0,0,1003,1004,5,119,0,0,1004,1049,5,82,0,0,1005,1006,5,23,0,0,1006,
        1007,5,81,0,0,1007,1008,5,119,0,0,1008,1009,3,288,144,0,1009,1010,
        5,82,0,0,1010,1049,1,0,0,0,1011,1012,5,23,0,0,1012,1013,5,81,0,0,
        1013,1014,5,119,0,0,1014,1015,3,288,144,0,1015,1016,5,111,0,0,1016,
        1017,5,82,0,0,1017,1049,1,0,0,0,1018,1019,5,23,0,0,1019,1020,5,81,
        0,0,1020,1021,5,120,0,0,1021,1049,5,82,0,0,1022,1023,5,23,0,0,1023,
        1024,5,81,0,0,1024,1025,5,120,0,0,1025,1026,3,288,144,0,1026,1027,
        5,82,0,0,1027,1049,1,0,0,0,1028,1029,5,23,0,0,1029,1030,5,81,0,0,
        1030,1031,5,120,0,0,1031,1032,3,288,144,0,1032,1033,5,111,0,0,1033,
        1034,5,82,0,0,1034,1049,1,0,0,0,1035,1036,5,26,0,0,1036,1037,5,81,
        0,0,1037,1049,5,82,0,0,1038,1039,5,26,0,0,1039,1040,5,81,0,0,1040,
        1041,3,250,125,0,1041,1042,5,82,0,0,1042,1049,1,0,0,0,1043,1044,
        5,26,0,0,1044,1045,5,81,0,0,1045,1046,3,272,136,0,1046,1047,5,82,
        0,0,1047,1049,1,0,0,0,1048,941,1,0,0,0,1048,944,1,0,0,0,1048,948,
        1,0,0,0,1048,953,1,0,0,0,1048,958,1,0,0,0,1048,961,1,0,0,0,1048,
        965,1,0,0,0,1048,971,1,0,0,0,1048,975,1,0,0,0,1048,981,1,0,0,0,1048,
        984,1,0,0,0,1048,988,1,0,0,0,1048,994,1,0,0,0,1048,1001,1,0,0,0,
        1048,1005,1,0,0,0,1048,1011,1,0,0,0,1048,1018,1,0,0,0,1048,1022,
        1,0,0,0,1048,1028,1,0,0,0,1048,1035,1,0,0,0,1048,1038,1,0,0,0,1048,
        1043,1,0,0,0,1049,169,1,0,0,0,1050,1055,3,172,86,0,1051,1052,5,84,
        0,0,1052,1054,3,172,86,0,1053,1051,1,0,0,0,1054,1057,1,0,0,0,1055,
        1053,1,0,0,0,1055,1056,1,0,0,0,1056,171,1,0,0,0,1057,1055,1,0,0,
        0,1058,1064,3,174,87,0,1059,1064,3,180,90,0,1060,1064,3,184,92,0,
        1061,1064,3,188,94,0,1062,1064,3,192,96,0,1063,1058,1,0,0,0,1063,
        1059,1,0,0,0,1063,1060,1,0,0,0,1063,1061,1,0,0,0,1063,1062,1,0,0,
        0,1064,173,1,0,0,0,1065,1066,5,14,0,0,1066,1069,5,81,0,0,1067,1070,
        3,176,88,0,1068,1070,3,178,89,0,1069,1067,1,0,0,0,1069,1068,1,0,
        0,0,1070,1071,1,0,0,0,1071,1072,5,82,0,0,1072,175,1,0,0,0,1073,1074,
        7,5,0,0,1074,1075,5,102,0,0,1075,1076,3,290,145,0,1076,177,1,0,0,
        0,1077,1078,7,5,0,0,1078,1079,7,4,0,0,1079,1080,5,64,0,0,1080,179,
        1,0,0,0,1081,1082,5,17,0,0,1082,1083,5,81,0,0,1083,1084,3,182,91,
        0,1084,1085,5,82,0,0,1085,181,1,0,0,0,1086,1087,7,6,0,0,1087,1088,
        3,276,138,0,1088,1089,3,286,143,0,1089,183,1,0,0,0,1090,1091,5,23,
        0,0,1091,1092,5,81,0,0,1092,1093,3,186,93,0,1093,1094,5,82,0,0,1094,
        185,1,0,0,0,1095,1098,3,278,139,0,1096,1098,3,280,140,0,1097,1095,
        1,0,0,0,1097,1096,1,0,0,0,1098,1099,1,0,0,0,1099,1100,5,152,0,0,
        1100,187,1,0,0,0,1101,1102,5,26,0,0,1102,1103,5,81,0,0,1103,1104,
        3,190,95,0,1104,1105,5,82,0,0,1105,189,1,0,0,0,1106,1109,3,248,124,
        0,1107,1109,3,270,135,0,1108,1106,1,0,0,0,1108,1107,1,0,0,0,1109,
        191,1,0,0,0,1110,1111,5,14,0,0,1111,1112,5,81,0,0,1112,1222,5,82,
        0,0,1113,1114,5,14,0,0,1114,1115,5,81,0,0,1115,1116,5,164,0,0,1116,
        1222,5,82,0,0,1117,1118,5,14,0,0,1118,1119,5,81,0,0,1119,1120,5,
        164,0,0,1120,1121,5,102,0,0,1121,1222,5,82,0,0,1122,1123,5,14,0,
        0,1123,1124,5,81,0,0,1124,1125,5,164,0,0,1125,1126,7,4,0,0,1126,
        1222,5,82,0,0,1127,1128,5,14,0,0,1128,1129,5,81,0,0,1129,1130,5,
        170,0,0,1130,1222,5,82,0,0,1131,1132,5,14,0,0,1132,1133,5,81,0,0,
        1133,1134,5,170,0,0,1134,1135,5,102,0,0,1135,1222,5,82,0,0,1136,
        1137,5,14,0,0,1137,1138,5,81,0,0,1138,1139,5,170,0,0,1139,1140,7,
        4,0,0,1140,1222,5,82,0,0,1141,1142,5,17,0,0,1142,1143,5,81,0,0,1143,
        1222,5,82,0,0,1144,1145,5,17,0,0,1145,1146,5,81,0,0,1146,1147,7,
        6,0,0,1147,1222,5,82,0,0,1148,1149,5,17,0,0,1149,1150,5,81,0,0,1150,
        1151,7,6,0,0,1151,1152,3,276,138,0,1152,1153,5,82,0,0,1153,1222,
        1,0,0,0,1154,1155,5,23,0,0,1155,1156,5,81,0,0,1156,1222,5,82,0,0,
        1157,1158,5,23,0,0,1158,1159,5,81,0,0,1159,1160,5,116,0,0,1160,1222,
        5,82,0,0,1161,1162,5,23,0,0,1162,1163,5,81,0,0,1163,1164,5,116,0,
        0,1164,1165,3,288,144,0,1165,1166,5,82,0,0,1166,1222,1,0,0,0,1167,
        1168,5,23,0,0,1168,1169,5,81,0,0,1169,1170,5,116,0,0,1170,1171,3,
        288,144,0,1171,1172,5,111,0,0,1172,1173,5,82,0,0,1173,1222,1,0,0,
        0,1174,1175,5,23,0,0,1175,1176,5,81,0,0,1176,1177,5,119,0,0,1177,
        1222,5,82,0,0,1178,1179,5,23,0,0,1179,1180,5,81,0,0,1180,1181,5,
        119,0,0,1181,1182,3,288,144,0,1182,1183,5,82,0,0,1183,1222,1,0,0,
        0,1184,1185,5,23,0,0,1185,1186,5,81,0,0,1186,1187,5,119,0,0,1187,
        1188,3,288,144,0,1188,1189,5,111,0,0,1189,1190,5,82,0,0,1190,1222,
        1,0,0,0,1191,1192,5,23,0,0,1192,1193,5,81,0,0,1193,1194,5,120,0,
        0,1194,1222,5,82,0,0,1195,1196,5,23,0,0,1196,1197,5,81,0,0,1197,
        1198,5,120,0,0,1198,1199,3,288,144,0,1199,1200,5,82,0,0,1200,1222,
        1,0,0,0,1201,1202,5,23,0,0,1202,1203,5,81,0,0,1203,1204,5,120,0,
        0,1204,1205,3,288,144,0,1205,1206,5,111,0,0,1206,1207,5,82,0,0,1207,
        1222,1,0,0,0,1208,1209,5,26,0,0,1209,1210,5,81,0,0,1210,1222,5,82,
        0,0,1211,1212,5,26,0,0,1212,1213,5,81,0,0,1213,1214,3,250,125,0,
        1214,1215,5,82,0,0,1215,1222,1,0,0,0,1216,1217,5,26,0,0,1217,1218,
        5,81,0,0,1218,1219,3,272,136,0,1219,1220,5,82,0,0,1220,1222,1,0,
        0,0,1221,1110,1,0,0,0,1221,1113,1,0,0,0,1221,1117,1,0,0,0,1221,1122,
        1,0,0,0,1221,1127,1,0,0,0,1221,1131,1,0,0,0,1221,1136,1,0,0,0,1221,
        1141,1,0,0,0,1221,1144,1,0,0,0,1221,1148,1,0,0,0,1221,1154,1,0,0,
        0,1221,1157,1,0,0,0,1221,1161,1,0,0,0,1221,1167,1,0,0,0,1221,1174,
        1,0,0,0,1221,1178,1,0,0,0,1221,1184,1,0,0,0,1221,1191,1,0,0,0,1221,
        1195,1,0,0,0,1221,1201,1,0,0,0,1221,1208,1,0,0,0,1221,1211,1,0,0,
        0,1221,1216,1,0,0,0,1222,193,1,0,0,0,1223,1228,3,196,98,0,1224,1225,
        5,84,0,0,1225,1227,3,196,98,0,1226,1224,1,0,0,0,1227,1230,1,0,0,
        0,1228,1226,1,0,0,0,1228,1229,1,0,0,0,1229,195,1,0,0,0,1230,1228,
        1,0,0,0,1231,1237,3,198,99,0,1232,1237,3,204,102,0,1233,1237,3,208,
        104,0,1234,1237,3,212,106,0,1235,1237,3,216,108,0,1236,1231,1,0,
        0,0,1236,1232,1,0,0,0,1236,1233,1,0,0,0,1236,1234,1,0,0,0,1236,1235,
        1,0,0,0,1237,197,1,0,0,0,1238,1239,5,14,0,0,1239,1242,5,81,0,0,1240,
        1243,3,200,100,0,1241,1243,3,202,101,0,1242,1240,1,0,0,0,1242,1241,
        1,0,0,0,1243,1244,1,0,0,0,1244,1245,5,82,0,0,1245,199,1,0,0,0,1246,
        1247,7,7,0,0,1247,1248,5,102,0,0,1248,1249,3,290,145,0,1249,201,
        1,0,0,0,1250,1251,7,7,0,0,1251,1252,7,4,0,0,1252,1253,5,64,0,0,1253,
        203,1,0,0,0,1254,1255,5,17,0,0,1255,1256,5,81,0,0,1256,1257,3,206,
        103,0,1257,1258,5,82,0,0,1258,205,1,0,0,0,1259,1260,5,160,0,0,1260,
        1261,3,276,138,0,1261,1262,3,286,143,0,1262,207,1,0,0,0,1263,1264,
        5,23,0,0,1264,1265,5,81,0,0,1265,1266,3,210,105,0,1266,1267,5,82,
        0,0,1267,209,1,0,0,0,1268,1271,3,278,139,0,1269,1271,3,280,140,0,
        1270,1268,1,0,0,0,1270,1269,1,0,0,0,1271,1272,1,0,0,0,1272,1273,
        5,153,0,0,1273,211,1,0,0,0,1274,1275,5,26,0,0,1275,1276,5,81,0,0,
        1276,1277,3,214,107,0,1277,1278,5,82,0,0,1278,213,1,0,0,0,1279,1282,
        3,248,124,0,1280,1282,3,270,135,0,1281,1279,1,0,0,0,1281,1280,1,
        0,0,0,1282,215,1,0,0,0,1283,1284,5,14,0,0,1284,1285,5,81,0,0,1285,
        1395,5,82,0,0,1286,1287,5,14,0,0,1287,1288,5,81,0,0,1288,1289,5,
        165,0,0,1289,1395,5,82,0,0,1290,1291,5,14,0,0,1291,1292,5,81,0,0,
        1292,1293,5,165,0,0,1293,1294,5,102,0,0,1294,1395,5,82,0,0,1295,
        1296,5,14,0,0,1296,1297,5,81,0,0,1297,1298,5,165,0,0,1298,1299,7,
        4,0,0,1299,1395,5,82,0,0,1300,1301,5,14,0,0,1301,1302,5,81,0,0,1302,
        1303,5,170,0,0,1303,1395,5,82,0,0,1304,1305,5,14,0,0,1305,1306,5,
        81,0,0,1306,1307,5,170,0,0,1307,1308,5,102,0,0,1308,1395,5,82,0,
        0,1309,1310,5,14,0,0,1310,1311,5,81,0,0,1311,1312,5,170,0,0,1312,
        1313,7,4,0,0,1313,1395,5,82,0,0,1314,1315,5,17,0,0,1315,1316,5,81,
        0,0,1316,1395,5,82,0,0,1317,1318,5,17,0,0,1318,1319,5,81,0,0,1319,
        1320,5,160,0,0,1320,1395,5,82,0,0,1321,1322,5,17,0,0,1322,1323,5,
        81,0,0,1323,1324,5,160,0,0,1324,1325,3,276,138,0,1325,1326,5,82,
        0,0,1326,1395,1,0,0,0,1327,1328,5,23,0,0,1328,1329,5,81,0,0,1329,
        1395,5,82,0,0,1330,1331,5,23,0,0,1331,1332,5,81,0,0,1332,1333,5,
        116,0,0,1333,1395,5,82,0,0,1334,1335,5,23,0,0,1335,1336,5,81,0,0,
        1336,1337,5,116,0,0,1337,1338,3,288,144,0,1338,1339,5,82,0,0,1339,
        1395,1,0,0,0,1340,1341,5,23,0,0,1341,1342,5,81,0,0,1342,1343,5,116,
        0,0,1343,1344,3,288,144,0,1344,1345,5,111,0,0,1345,1346,5,82,0,0,
        1346,1395,1,0,0,0,1347,1348,5,23,0,0,1348,1349,5,81,0,0,1349,1350,
        5,119,0,0,1350,1395,5,82,0,0,1351,1352,5,23,0,0,1352,1353,5,81,0,
        0,1353,1354,5,119,0,0,1354,1355,3,288,144,0,1355,1356,5,82,0,0,1356,
        1395,1,0,0,0,1357,1358,5,23,0,0,1358,1359,5,81,0,0,1359,1360,5,119,
        0,0,1360,1361,3,288,144,0,1361,1362,5,111,0,0,1362,1363,5,82,0,0,
        1363,1395,1,0,0,0,1364,1365,5,23,0,0,1365,1366,5,81,0,0,1366,1367,
        5,120,0,0,1367,1395,5,82,0,0,1368,1369,5,23,0,0,1369,1370,5,81,0,
        0,1370,1371,5,120,0,0,1371,1372,3,288,144,0,1372,1373,5,82,0,0,1373,
        1395,1,0,0,0,1374,1375,5,23,0,0,1375,1376,5,81,0,0,1376,1377,5,120,
        0,0,1377,1378,3,288,144,0,1378,1379,5,111,0,0,1379,1380,5,82,0,0,
        1380,1395,1,0,0,0,1381,1382,5,26,0,0,1382,1383,5,81,0,0,1383,1395,
        5,82,0,0,1384,1385,5,26,0,0,1385,1386,5,81,0,0,1386,1387,3,250,125,
        0,1387,1388,5,82,0,0,1388,1395,1,0,0,0,1389,1390,5,26,0,0,1390,1391,
        5,81,0,0,1391,1392,3,272,136,0,1392,1393,5,82,0,0,1393,1395,1,0,
        0,0,1394,1283,1,0,0,0,1394,1286,1,0,0,0,1394,1290,1,0,0,0,1394,1295,
        1,0,0,0,1394,1300,1,0,0,0,1394,1304,1,0,0,0,1394,1309,1,0,0,0,1394,
        1314,1,0,0,0,1394,1317,1,0,0,0,1394,1321,1,0,0,0,1394,1327,1,0,0,
        0,1394,1330,1,0,0,0,1394,1334,1,0,0,0,1394,1340,1,0,0,0,1394,1347,
        1,0,0,0,1394,1351,1,0,0,0,1394,1357,1,0,0,0,1394,1364,1,0,0,0,1394,
        1368,1,0,0,0,1394,1374,1,0,0,0,1394,1381,1,0,0,0,1394,1384,1,0,0,
        0,1394,1389,1,0,0,0,1395,217,1,0,0,0,1396,1401,3,220,110,0,1397,
        1398,5,84,0,0,1398,1400,3,220,110,0,1399,1397,1,0,0,0,1400,1403,
        1,0,0,0,1401,1399,1,0,0,0,1401,1402,1,0,0,0,1402,219,1,0,0,0,1403,
        1401,1,0,0,0,1404,1410,3,222,111,0,1405,1410,3,228,114,0,1406,1410,
        3,232,116,0,1407,1410,3,236,118,0,1408,1410,3,240,120,0,1409,1404,
        1,0,0,0,1409,1405,1,0,0,0,1409,1406,1,0,0,0,1409,1407,1,0,0,0,1409,
        1408,1,0,0,0,1410,221,1,0,0,0,1411,1412,5,14,0,0,1412,1415,5,81,
        0,0,1413,1416,3,224,112,0,1414,1416,3,226,113,0,1415,1413,1,0,0,
        0,1415,1414,1,0,0,0,1416,1417,1,0,0,0,1417,1418,5,82,0,0,1418,223,
        1,0,0,0,1419,1420,5,167,0,0,1420,1421,5,102,0,0,1421,1422,3,290,
        145,0,1422,225,1,0,0,0,1423,1424,5,167,0,0,1424,1425,7,4,0,0,1425,
        1426,5,64,0,0,1426,227,1,0,0,0,1427,1428,5,17,0,0,1428,1429,5,81,
        0,0,1429,1430,3,230,115,0,1430,1431,5,82,0,0,1431,229,1,0,0,0,1432,
        1433,5,161,0,0,1433,1434,3,276,138,0,1434,1435,3,288,144,0,1435,
        231,1,0,0,0,1436,1437,5,23,0,0,1437,1438,5,81,0,0,1438,1439,3,234,
        117,0,1439,1440,5,82,0,0,1440,233,1,0,0,0,1441,1444,3,278,139,0,
        1442,1444,3,280,140,0,1443,1441,1,0,0,0,1443,1442,1,0,0,0,1444,1445,
        1,0,0,0,1445,1446,5,154,0,0,1446,235,1,0,0,0,1447,1448,5,26,0,0,
        1448,1449,5,81,0,0,1449,1450,3,238,119,0,1450,1451,5,82,0,0,1451,
        237,1,0,0,0,1452,1455,3,248,124,0,1453,1455,3,270,135,0,1454,1452,
        1,0,0,0,1454,1453,1,0,0,0,1455,239,1,0,0,0,1456,1457,5,14,0,0,1457,
        1458,5,81,0,0,1458,1554,5,82,0,0,1459,1460,5,14,0,0,1460,1461,5,
        81,0,0,1461,1462,5,167,0,0,1462,1554,5,82,0,0,1463,1464,5,14,0,0,
        1464,1465,5,81,0,0,1465,1466,5,167,0,0,1466,1467,5,102,0,0,1467,
        1554,5,82,0,0,1468,1469,5,14,0,0,1469,1470,5,81,0,0,1470,1471,5,
        167,0,0,1471,1472,7,4,0,0,1472,1554,5,82,0,0,1473,1474,5,17,0,0,
        1474,1475,5,81,0,0,1475,1554,5,82,0,0,1476,1477,5,17,0,0,1477,1478,
        5,81,0,0,1478,1479,5,161,0,0,1479,1554,5,82,0,0,1480,1481,5,17,0,
        0,1481,1482,5,81,0,0,1482,1483,5,161,0,0,1483,1484,3,276,138,0,1484,
        1485,5,82,0,0,1485,1554,1,0,0,0,1486,1487,5,23,0,0,1487,1488,5,81,
        0,0,1488,1554,5,82,0,0,1489,1490,5,23,0,0,1490,1491,5,81,0,0,1491,
        1492,5,116,0,0,1492,1554,5,82,0,0,1493,1494,5,23,0,0,1494,1495,5,
        81,0,0,1495,1496,5,116,0,0,1496,1497,3,288,144,0,1497,1498,5,82,
        0,0,1498,1554,1,0,0,0,1499,1500,5,23,0,0,1500,1501,5,81,0,0,1501,
        1502,5,116,0,0,1502,1503,3,288,144,0,1503,1504,5,111,0,0,1504,1505,
        5,82,0,0,1505,1554,1,0,0,0,1506,1507,5,23,0,0,1507,1508,5,81,0,0,
        1508,1509,5,119,0,0,1509,1554,5,82,0,0,1510,1511,5,23,0,0,1511,1512,
        5,81,0,0,1512,1513,5,119,0,0,1513,1514,3,288,144,0,1514,1515,5,82,
        0,0,1515,1554,1,0,0,0,1516,1517,5,23,0,0,1517,1518,5,81,0,0,1518,
        1519,5,119,0,0,1519,1520,3,288,144,0,1520,1521,5,111,0,0,1521,1522,
        5,82,0,0,1522,1554,1,0,0,0,1523,1524,5,23,0,0,1524,1525,5,81,0,0,
        1525,1526,5,120,0,0,1526,1554,5,82,0,0,1527,1528,5,23,0,0,1528,1529,
        5,81,0,0,1529,1530,5,120,0,0,1530,1531,3,288,144,0,1531,1532,5,82,
        0,0,1532,1554,1,0,0,0,1533,1534,5,23,0,0,1534,1535,5,81,0,0,1535,
        1536,5,120,0,0,1536,1537,3,288,144,0,1537,1538,5,111,0,0,1538,1539,
        5,82,0,0,1539,1554,1,0,0,0,1540,1541,5,26,0,0,1541,1542,5,81,0,0,
        1542,1554,5,82,0,0,1543,1544,5,26,0,0,1544,1545,5,81,0,0,1545,1546,
        3,250,125,0,1546,1547,5,82,0,0,1547,1554,1,0,0,0,1548,1549,5,26,
        0,0,1549,1550,5,81,0,0,1550,1551,3,272,136,0,1551,1552,5,82,0,0,
        1552,1554,1,0,0,0,1553,1456,1,0,0,0,1553,1459,1,0,0,0,1553,1463,
        1,0,0,0,1553,1468,1,0,0,0,1553,1473,1,0,0,0,1553,1476,1,0,0,0,1553,
        1480,1,0,0,0,1553,1486,1,0,0,0,1553,1489,1,0,0,0,1553,1493,1,0,0,
        0,1553,1499,1,0,0,0,1553,1506,1,0,0,0,1553,1510,1,0,0,0,1553,1516,
        1,0,0,0,1553,1523,1,0,0,0,1553,1527,1,0,0,0,1553,1533,1,0,0,0,1553,
        1540,1,0,0,0,1553,1543,1,0,0,0,1553,1548,1,0,0,0,1554,241,1,0,0,
        0,1555,1556,5,14,0,0,1556,1559,5,81,0,0,1557,1560,3,244,122,0,1558,
        1560,3,246,123,0,1559,1557,1,0,0,0,1559,1558,1,0,0,0,1560,1561,1,
        0,0,0,1561,1562,5,82,0,0,1562,243,1,0,0,0,1563,1564,5,168,0,0,1564,
        1565,5,102,0,0,1565,1566,3,290,145,0,1566,245,1,0,0,0,1567,1568,
        5,168,0,0,1568,1569,7,4,0,0,1569,1570,5,64,0,0,1570,247,1,0,0,0,
        1571,1574,5,130,0,0,1572,1575,3,244,122,0,1573,1575,3,246,123,0,
        1574,1572,1,0,0,0,1574,1573,1,0,0,0,1575,249,1,0,0,0,1576,1587,1,
        0,0,0,1577,1587,5,130,0,0,1578,1579,5,130,0,0,1579,1587,5,168,0,
        0,1580,1581,5,130,0,0,1581,1582,5,168,0,0,1582,1587,5,102,0,0,1583,
        1584,5,130,0,0,1584,1585,5,168,0,0,1585,1587,7,4,0,0,1586,1576,1,
        0,0,0,1586,1577,1,0,0,0,1586,1578,1,0,0,0,1586,1580,1,0,0,0,1586,
        1583,1,0,0,0,1587,251,1,0,0,0,1588,1593,3,254,127,0,1589,1590,5,
        84,0,0,1590,1592,3,254,127,0,1591,1589,1,0,0,0,1592,1595,1,0,0,0,
        1593,1591,1,0,0,0,1593,1594,1,0,0,0,1594,253,1,0,0,0,1595,1593,1,
        0,0,0,1596,1601,3,256,128,0,1597,1601,3,262,131,0,1598,1601,3,266,
        133,0,1599,1601,3,274,137,0,1600,1596,1,0,0,0,1600,1597,1,0,0,0,
        1600,1598,1,0,0,0,1600,1599,1,0,0,0,1601,255,1,0,0,0,1602,1603,5,
        14,0,0,1603,1606,5,81,0,0,1604,1607,3,258,129,0,1605,1607,3,260,
        130,0,1606,1604,1,0,0,0,1606,1605,1,0,0,0,1607,1608,1,0,0,0,1608,
        1609,5,82,0,0,1609,257,1,0,0,0,1610,1611,5,169,0,0,1611,1612,5,102,
        0,0,1612,1613,3,290,145,0,1613,259,1,0,0,0,1614,1615,5,169,0,0,1615,
        1616,7,4,0,0,1616,1617,5,64,0,0,1617,261,1,0,0,0,1618,1619,5,23,
        0,0,1619,1620,5,81,0,0,1620,1621,3,264,132,0,1621,1622,5,82,0,0,
        1622,263,1,0,0,0,1623,1626,3,278,139,0,1624,1626,3,280,140,0,1625,
        1623,1,0,0,0,1625,1624,1,0,0,0,1626,1627,1,0,0,0,1627,1628,5,155,
        0,0,1628,265,1,0,0,0,1629,1630,5,26,0,0,1630,1631,5,81,0,0,1631,
        1632,3,268,134,0,1632,1633,5,82,0,0,1633,267,1,0,0,0,1634,1637,3,
        248,124,0,1635,1637,3,138,69,0,1636,1634,1,0,0,0,1636,1635,1,0,0,
        0,1637,269,1,0,0,0,1638,1641,5,131,0,0,1639,1642,3,258,129,0,1640,
        1642,3,260,130,0,1641,1639,1,0,0,0,1641,1640,1,0,0,0,1642,271,1,
        0,0,0,1643,1654,1,0,0,0,1644,1654,5,131,0,0,1645,1646,5,131,0,0,
        1646,1654,5,169,0,0,1647,1648,5,131,0,0,1648,1649,5,169,0,0,1649,
        1654,5,102,0,0,1650,1651,5,131,0,0,1651,1652,5,169,0,0,1652,1654,
        7,4,0,0,1653,1643,1,0,0,0,1653,1644,1,0,0,0,1653,1645,1,0,0,0,1653,
        1647,1,0,0,0,1653,1650,1,0,0,0,1654,273,1,0,0,0,1655,1656,5,14,0,
        0,1656,1657,5,81,0,0,1657,1740,5,82,0,0,1658,1659,5,14,0,0,1659,
        1660,5,81,0,0,1660,1661,5,169,0,0,1661,1740,5,82,0,0,1662,1663,5,
        14,0,0,1663,1664,5,81,0,0,1664,1665,5,169,0,0,1665,1666,5,102,0,
        0,1666,1740,5,82,0,0,1667,1668,5,14,0,0,1668,1669,5,81,0,0,1669,
        1670,5,169,0,0,1670,1671,7,4,0,0,1671,1740,5,82,0,0,1672,1673,5,
        23,0,0,1673,1674,5,81,0,0,1674,1740,5,82,0,0,1675,1676,5,23,0,0,
        1676,1677,5,81,0,0,1677,1678,5,116,0,0,1678,1740,5,82,0,0,1679,1680,
        5,23,0,0,1680,1681,5,81,0,0,1681,1682,5,116,0,0,1682,1683,3,288,
        144,0,1683,1684,5,82,0,0,1684,1740,1,0,0,0,1685,1686,5,23,0,0,1686,
        1687,5,81,0,0,1687,1688,5,116,0,0,1688,1689,3,288,144,0,1689,1690,
        5,111,0,0,1690,1691,5,82,0,0,1691,1740,1,0,0,0,1692,1693,5,23,0,
        0,1693,1694,5,81,0,0,1694,1695,5,119,0,0,1695,1740,5,82,0,0,1696,
        1697,5,23,0,0,1697,1698,5,81,0,0,1698,1699,5,119,0,0,1699,1700,3,
        288,144,0,1700,1701,5,82,0,0,1701,1740,1,0,0,0,1702,1703,5,23,0,
        0,1703,1704,5,81,0,0,1704,1705,5,119,0,0,1705,1706,3,288,144,0,1706,
        1707,5,111,0,0,1707,1708,5,82,0,0,1708,1740,1,0,0,0,1709,1710,5,
        23,0,0,1710,1711,5,81,0,0,1711,1712,5,120,0,0,1712,1740,5,82,0,0,
        1713,1714,5,23,0,0,1714,1715,5,81,0,0,1715,1716,5,120,0,0,1716,1717,
        3,288,144,0,1717,1718,5,82,0,0,1718,1740,1,0,0,0,1719,1720,5,23,
        0,0,1720,1721,5,81,0,0,1721,1722,5,120,0,0,1722,1723,3,288,144,0,
        1723,1724,5,111,0,0,1724,1725,5,82,0,0,1725,1740,1,0,0,0,1726,1727,
        5,26,0,0,1727,1728,5,81,0,0,1728,1740,5,82,0,0,1729,1730,5,26,0,
        0,1730,1731,5,81,0,0,1731,1732,3,250,125,0,1732,1733,5,82,0,0,1733,
        1740,1,0,0,0,1734,1735,5,26,0,0,1735,1736,5,81,0,0,1736,1737,3,140,
        70,0,1737,1738,5,82,0,0,1738,1740,1,0,0,0,1739,1655,1,0,0,0,1739,
        1658,1,0,0,0,1739,1662,1,0,0,0,1739,1667,1,0,0,0,1739,1672,1,0,0,
        0,1739,1675,1,0,0,0,1739,1679,1,0,0,0,1739,1685,1,0,0,0,1739,1692,
        1,0,0,0,1739,1696,1,0,0,0,1739,1702,1,0,0,0,1739,1709,1,0,0,0,1739,
        1713,1,0,0,0,1739,1719,1,0,0,0,1739,1726,1,0,0,0,1739,1729,1,0,0,
        0,1739,1734,1,0,0,0,1740,275,1,0,0,0,1741,1742,7,8,0,0,1742,277,
        1,0,0,0,1743,1744,5,116,0,0,1744,1745,3,288,144,0,1745,1746,5,111,
        0,0,1746,279,1,0,0,0,1747,1750,3,282,141,0,1748,1750,3,284,142,0,
        1749,1747,1,0,0,0,1749,1748,1,0,0,0,1750,281,1,0,0,0,1751,1752,5,
        119,0,0,1752,1753,3,288,144,0,1753,1754,5,111,0,0,1754,283,1,0,0,
        0,1755,1756,5,120,0,0,1756,1757,3,288,144,0,1757,1758,5,111,0,0,
        1758,285,1,0,0,0,1759,1768,3,288,144,0,1760,1762,5,76,0,0,1761,1760,
        1,0,0,0,1761,1762,1,0,0,0,1762,1763,1,0,0,0,1763,1765,5,121,0,0,
        1764,1766,5,76,0,0,1765,1764,1,0,0,0,1765,1766,1,0,0,0,1766,1768,
        1,0,0,0,1767,1759,1,0,0,0,1767,1761,1,0,0,0,1768,287,1,0,0,0,1769,
        1770,5,76,0,0,1770,289,1,0,0,0,1771,1776,5,48,0,0,1772,1773,5,84,
        0,0,1773,1775,5,48,0,0,1774,1772,1,0,0,0,1775,1778,1,0,0,0,1776,
        1774,1,0,0,0,1776,1777,1,0,0,0,1777,291,1,0,0,0,1778,1776,1,0,0,
        0,83,301,313,319,324,355,364,374,378,382,388,401,459,474,481,485,
        500,506,513,528,535,541,549,569,589,607,621,629,647,682,689,696,
        703,710,717,726,733,739,758,769,774,786,872,879,887,893,909,928,
        939,1048,1055,1063,1069,1097,1108,1221,1228,1236,1242,1270,1281,
        1394,1401,1409,1415,1443,1454,1553,1559,1574,1586,1593,1600,1606,
        1625,1636,1641,1653,1739,1749,1761,1765,1767,1776
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!IndexDate.__ATN) {
            IndexDate.__ATN = new antlr.ATNDeserializer().deserialize(IndexDate._serializedATN);
        }

        return IndexDate.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(IndexDate.literalNames, IndexDate.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return IndexDate.vocabulary;
    }

    private static readonly decisionsToDFA = IndexDate._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class Index_dateContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX_DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.INDEX_DATE, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public index_date_definition(): Index_date_definitionContext {
        return this.getRuleContext(0, Index_date_definitionContext)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_index_date;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterIndex_date) {
             listener.enterIndex_date(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitIndex_date) {
             listener.exitIndex_date(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitIndex_date) {
            return visitor.visitIndex_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_definitionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public calendar_date(): Calendar_dateContext | null {
        return this.getRuleContext(0, Calendar_dateContext);
    }
    public calendarError(): CalendarErrorContext | null {
        return this.getRuleContext(0, CalendarErrorContext);
    }
    public index_event_date(): Index_event_dateContext | null {
        return this.getRuleContext(0, Index_event_dateContext);
    }
    public index_event_date_error(): Index_event_date_errorContext | null {
        return this.getRuleContext(0, Index_event_date_errorContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_index_date_definition;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterIndex_date_definition) {
             listener.enterIndex_date_definition(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitIndex_date_definition) {
             listener.exitIndex_date_definition(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_definition) {
            return visitor.visitIndex_date_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Calendar_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.CALENDAR_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_calendar_date;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCalendar_date) {
             listener.enterCalendar_date(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCalendar_date) {
             listener.exitCalendar_date(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCalendar_date) {
            return visitor.visitCalendar_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public _date?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.EVENT, 0)!;
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.INSTANCE_EVENT_NAME, 0);
    }
    public PERSON_DATE_TIME_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.PERSON_DATE_TIME_ATTRIBUTE, 0);
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMA, 0);
    }
    public index_date_bounds(): Index_date_boundsContext | null {
        return this.getRuleContext(0, Index_date_boundsContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_index_event_date;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterIndex_event_date) {
             listener.enterIndex_event_date(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitIndex_event_date) {
             listener.exitIndex_event_date(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date) {
            return visitor.visitIndex_event_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(IndexDate.COMMA, 0)!;
    }
    public lower_date_bounds(): Lower_date_boundsContext | null {
        return this.getRuleContext(0, Lower_date_boundsContext);
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext | null {
        return this.getRuleContext(0, Lower_date_bounds_errorContext);
    }
    public upper_date_bounds(): Upper_date_boundsContext | null {
        return this.getRuleContext(0, Upper_date_boundsContext);
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext | null {
        return this.getRuleContext(0, Upper_date_bounds_errorContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_index_date_bounds;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterIndex_date_bounds) {
             listener.enterIndex_date_bounds(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitIndex_date_bounds) {
             listener.exitIndex_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_bounds) {
            return visitor.visitIndex_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(IndexDate.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_upper_date_bounds;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterUpper_date_bounds) {
             listener.enterUpper_date_bounds(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitUpper_date_bounds) {
             listener.exitUpper_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds) {
            return visitor.visitUpper_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(IndexDate.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_lower_date_bounds;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterLower_date_bounds) {
             listener.enterLower_date_bounds(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitLower_date_bounds) {
             listener.exitLower_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds) {
            return visitor.visitLower_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class CalendarErrorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.CALENDAR_DATE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_calendarError;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCalendarError) {
             listener.enterCalendarError(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCalendarError) {
             listener.exitCalendarError(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCalendarError) {
            return visitor.visitCalendarError(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_date_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_index_event_date_error;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterIndex_event_date_error) {
             listener.enterIndex_event_date_error(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitIndex_event_date_error) {
             listener.exitIndex_event_date_error(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date_error) {
            return visitor.visitIndex_event_date_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(IndexDate.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_lower_date_bounds_error;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterLower_date_bounds_error) {
             listener.enterLower_date_bounds_error(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitLower_date_bounds_error) {
             listener.exitLower_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds_error) {
            return visitor.visitLower_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(IndexDate.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_upper_date_bounds_error;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterUpper_date_bounds_error) {
             listener.enterUpper_date_bounds_error(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitUpper_date_bounds_error) {
             listener.exitUpper_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds_error) {
            return visitor.visitUpper_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event(): Merged_eventContext | null {
        return this.getRuleContext(0, Merged_eventContext);
    }
    public sequence_event(): Sequence_eventContext | null {
        return this.getRuleContext(0, Sequence_eventContext);
    }
    public instance_event(): Instance_eventContext | null {
        return this.getRuleContext(0, Instance_eventContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_derived_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDerived_event) {
             listener.enterDerived_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDerived_event) {
             listener.exitDerived_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDerived_event) {
            return visitor.visitDerived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MERGED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(IndexDate.MERGED_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public MERGED_EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.MERGED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        return this.getRuleContext(0, Merged_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMA, 0);
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext | null {
        return this.getRuleContext(0, Merged_event_filter_criterionContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event) {
             listener.enterMerged_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event) {
             listener.exitMerged_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event) {
            return visitor.visitMerged_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_criterion(): Merged_event_criterionContext[];
    public merged_event_criterion(i: number): Merged_event_criterionContext | null;
    public merged_event_criterion(i?: number): Merged_event_criterionContext[] | Merged_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Merged_event_criterionContext);
        }

        return this.getRuleContext(i, Merged_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_criteria) {
             listener.enterMerged_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_criteria) {
             listener.exitMerged_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criteria) {
            return visitor.visitMerged_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_event(): Merged_event_eventContext | null {
        return this.getRuleContext(0, Merged_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_criterion;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_criterion) {
             listener.enterMerged_event_criterion(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_criterion) {
             listener.exitMerged_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criterion) {
            return visitor.visitMerged_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_filter(): Merged_event_filterContext | null {
        return this.getRuleContext(0, Merged_event_filterContext);
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext | null {
        return this.getRuleContext(0, Merged_event_filter_errorContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_filter_criterion;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_filter_criterion) {
             listener.enterMerged_event_filter_criterion(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_filter_criterion) {
             listener.exitMerged_event_filter_criterion(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_criterion) {
            return visitor.visitMerged_event_filter_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_event) {
             listener.enterMerged_event_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_event) {
             listener.exitMerged_event_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_event) {
            return visitor.visitMerged_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filterContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_filter) {
             listener.enterMerged_event_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_filter) {
             listener.exitMerged_event_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter) {
            return visitor.visitMerged_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filter_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_uniqueness_filter) {
             listener.enterMerged_event_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_uniqueness_filter) {
             listener.exitMerged_event_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter) {
            return visitor.visitMerged_event_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filter_criteriaContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DERIVED_EVENT_DATE, 0)!;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filterContext);
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_uniqueness_filter_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_uniqueness_filter_criteria) {
             listener.enterMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_uniqueness_filter_criteria) {
             listener.exitMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter_criteria) {
            return visitor.visitMerged_event_uniqueness_filter_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public derived_event_int(): Derived_event_intContext | null {
        return this.getRuleContext(0, Derived_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_merged_event_filter_error;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMerged_event_filter_error) {
             listener.enterMerged_event_filter_error(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMerged_event_filter_error) {
             listener.exitMerged_event_filter_error(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_error) {
            return visitor.visitMerged_event_filter_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SEQUENCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEQUENCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public SEQUENCE_EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEQUENCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        return this.getRuleContext(0, Sequence_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_sequence_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSequence_event) {
             listener.enterSequence_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSequence_event) {
             listener.exitSequence_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSequence_event) {
            return visitor.visitSequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_criterion(): Sequence_event_criterionContext[];
    public sequence_event_criterion(i: number): Sequence_event_criterionContext | null;
    public sequence_event_criterion(i?: number): Sequence_event_criterionContext[] | Sequence_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Sequence_event_criterionContext);
        }

        return this.getRuleContext(i, Sequence_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_sequence_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSequence_event_criteria) {
             listener.enterSequence_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSequence_event_criteria) {
             listener.exitSequence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criteria) {
            return visitor.visitSequence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_constraint(): Sequence_event_constraintContext | null {
        return this.getRuleContext(0, Sequence_event_constraintContext);
    }
    public sequence_event_event(): Sequence_event_eventContext | null {
        return this.getRuleContext(0, Sequence_event_eventContext);
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext | null {
        return this.getRuleContext(0, Sequence_event_constraint_errorContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_sequence_event_criterion;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSequence_event_criterion) {
             listener.enterSequence_event_criterion(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSequence_event_criterion) {
             listener.exitSequence_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criterion) {
            return visitor.visitSequence_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ANY_ORDER(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ANY_ORDER, 0);
    }
    public temporal_constraint(): Temporal_constraintContext | null {
        return this.getRuleContext(0, Temporal_constraintContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_sequence_event_constraint;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSequence_event_constraint) {
             listener.enterSequence_event_constraint(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSequence_event_constraint) {
             listener.exitSequence_event_constraint(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint) {
            return visitor.visitSequence_event_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Temporal_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(IndexDate.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        return this.getRuleContext(0, Sequence_temporal_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_temporal_constraint;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterTemporal_constraint) {
             listener.enterTemporal_constraint(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitTemporal_constraint) {
             listener.exitTemporal_constraint(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitTemporal_constraint) {
            return visitor.visitTemporal_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_temporal_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(IndexDate.INT, 0)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(IndexDate.TIME_UNIT, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TOTAL_BETWEEN, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_sequence_temporal_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSequence_temporal_filter) {
             listener.enterSequence_temporal_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSequence_temporal_filter) {
             listener.exitSequence_temporal_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSequence_temporal_filter) {
            return visitor.visitSequence_temporal_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public selected_sequence_event(): Selected_sequence_eventContext | null {
        return this.getRuleContext(0, Selected_sequence_eventContext);
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext | null {
        return this.getRuleContext(0, Unselected_sequence_eventContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_sequence_event_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSequence_event_event) {
             listener.enterSequence_event_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSequence_event_event) {
             listener.exitSequence_event_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_event) {
            return visitor.visitSequence_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Selected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(IndexDate.COMMA, 0)!;
    }
    public IS_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.IS_EVENT_DATE, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_selected_sequence_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSelected_sequence_event) {
             listener.enterSelected_sequence_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSelected_sequence_event) {
             listener.exitSelected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSelected_sequence_event) {
            return visitor.visitSelected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Unselected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_unselected_sequence_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterUnselected_sequence_event) {
             listener.enterUnselected_sequence_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitUnselected_sequence_event) {
             listener.exitUnselected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitUnselected_sequence_event) {
            return visitor.visitUnselected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(IndexDate.INSTANCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public INSTANCE_EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.INSTANCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        return this.getRuleContext(0, Instance_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_instance_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterInstance_event) {
             listener.enterInstance_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitInstance_event) {
             listener.exitInstance_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitInstance_event) {
            return visitor.visitInstance_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_criterion(): Instance_event_criterionContext[];
    public instance_event_criterion(i: number): Instance_event_criterionContext | null;
    public instance_event_criterion(i?: number): Instance_event_criterionContext[] | Instance_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Instance_event_criterionContext);
        }

        return this.getRuleContext(i, Instance_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_instance_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterInstance_event_criteria) {
             listener.enterInstance_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitInstance_event_criteria) {
             listener.exitInstance_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criteria) {
            return visitor.visitInstance_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_event(): Instance_event_eventContext | null {
        return this.getRuleContext(0, Instance_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public instance_event_position(): Instance_event_positionContext | null {
        return this.getRuleContext(0, Instance_event_positionContext);
    }
    public instance_event_position_error(): Instance_event_position_errorContext | null {
        return this.getRuleContext(0, Instance_event_position_errorContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_instance_event_criterion;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterInstance_event_criterion) {
             listener.enterInstance_event_criterion(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitInstance_event_criterion) {
             listener.exitInstance_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criterion) {
            return visitor.visitInstance_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_instance_event_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterInstance_event_event) {
             listener.enterInstance_event_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitInstance_event_event) {
             listener.exitInstance_event_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_event) {
            return visitor.visitInstance_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_positionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(IndexDate.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext | null {
        return this.getRuleContext(0, Aggregation_qualifiedContext);
    }
    public specific_instance(): Specific_instanceContext | null {
        return this.getRuleContext(0, Specific_instanceContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_instance_event_position;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterInstance_event_position) {
             listener.enterInstance_event_position(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitInstance_event_position) {
             listener.exitInstance_event_position(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position) {
            return visitor.visitInstance_event_position(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Aggregation_qualifiedContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MAX(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MAX, 0);
    }
    public MIN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MIN, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_aggregation_qualified;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterAggregation_qualified) {
             listener.enterAggregation_qualified(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitAggregation_qualified) {
             listener.exitAggregation_qualified(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitAggregation_qualified) {
            return visitor.visitAggregation_qualified(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Specific_instanceContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX(): antlr.TerminalNode {
        return this.getToken(IndexDate.INDEX, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(IndexDate.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_specific_instance;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSpecific_instance) {
             listener.enterSpecific_instance(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSpecific_instance) {
             listener.exitSpecific_instance(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSpecific_instance) {
            return visitor.visitSpecific_instance(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_position_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(IndexDate.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode[];
    public OPEN_PAREN(i: number): antlr.TerminalNode | null;
    public OPEN_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.OPEN_PAREN);
    	} else {
    		return this.getToken(IndexDate.OPEN_PAREN, i);
    	}
    }
    public CLOSE_PAREN(): antlr.TerminalNode[];
    public CLOSE_PAREN(i: number): antlr.TerminalNode | null;
    public CLOSE_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.CLOSE_PAREN);
    	} else {
    		return this.getToken(IndexDate.CLOSE_PAREN, i);
    	}
    }
    public INDEX(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.INDEX, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_instance_event_position_error;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterInstance_event_position_error) {
             listener.enterInstance_event_position_error(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitInstance_event_position_error) {
             listener.exitInstance_event_position_error(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position_error) {
            return visitor.visitInstance_event_position_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(IndexDate.PERIOD, 0)!;
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MEASUREMENT_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.OBSERVATION_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_qualified_simple_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterQualified_simple_event) {
             listener.enterQualified_simple_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitQualified_simple_event) {
             listener.exitQualified_simple_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitQualified_simple_event) {
            return visitor.visitQualified_simple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(IndexDate.QUALIFIED_DERIVED_EVENT_NAME, 0)!;
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(IndexDate.PERIOD, 0)!;
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DERIVED_EVENT_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_qualified_derived_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterQualified_derived_event) {
             listener.enterQualified_derived_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitQualified_derived_event) {
             listener.exitQualified_derived_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitQualified_derived_event) {
            return visitor.visitQualified_derived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraint_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(IndexDate.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TOTAL_BETWEEN, 0);
    }
    public INT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.INT, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_sequence_event_constraint_error;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSequence_event_constraint_error) {
             listener.enterSequence_event_constraint_error(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSequence_event_constraint_error) {
             listener.exitSequence_event_constraint_error(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint_error) {
            return visitor.visitSequence_event_constraint_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUALIFIED_DERIVED_EVENT_NAME, 0);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.PERIOD, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_derived_event_error;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDerived_event_error) {
             listener.enterDerived_event_error(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDerived_event_error) {
             listener.exitDerived_event_error(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_error) {
            return visitor.visitDerived_event_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(IndexDate.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_derived_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDerived_uniqueness_filter) {
             listener.enterDerived_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDerived_uniqueness_filter) {
             listener.exitDerived_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter) {
            return visitor.visitDerived_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_fixed_window_uniqueness_filterContext);
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_derived_uniqueness_filter_window;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDerived_uniqueness_filter_window) {
             listener.enterDerived_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDerived_uniqueness_filter_window) {
             listener.exitDerived_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter_window) {
            return visitor.visitDerived_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(IndexDate.FIXED_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(IndexDate.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_derived_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDerived_fixed_window_uniqueness_filter) {
             listener.enterDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDerived_fixed_window_uniqueness_filter) {
             listener.exitDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDerived_fixed_window_uniqueness_filter) {
            return visitor.visitDerived_fixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(IndexDate.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_derived_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDerived_rolling_window_uniqueness_filter) {
             listener.enterDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDerived_rolling_window_uniqueness_filter) {
             listener.exitDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDerived_rolling_window_uniqueness_filter) {
            return visitor.visitDerived_rolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(IndexDate.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_derived_event_int;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDerived_event_int) {
             listener.enterDerived_event_int(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDerived_event_int) {
             listener.exitDerived_event_int(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_int) {
            return visitor.visitDerived_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext | null {
        return this.getRuleContext(0, Condition_occurrence_eventContext);
    }
    public drug_exposure_event(): Drug_exposure_eventContext | null {
        return this.getRuleContext(0, Drug_exposure_eventContext);
    }
    public measurement_event(): Measurement_eventContext | null {
        return this.getRuleContext(0, Measurement_eventContext);
    }
    public observation_event(): Observation_eventContext | null {
        return this.getRuleContext(0, Observation_eventContext);
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext | null {
        return this.getRuleContext(0, Procedure_occurrence_eventContext);
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext | null {
        return this.getRuleContext(0, Visit_occurrence_eventContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_simple_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSimple_event) {
             listener.enterSimple_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSimple_event) {
             listener.exitSimple_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSimple_event) {
            return visitor.visitSimple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Condition_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE_ALIAS, 0)!;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        return this.getRuleContext(0, Condition_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_event) {
             listener.enterCondition_occurrence_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_event) {
             listener.exitCondition_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event) {
            return visitor.visitCondition_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Drug_exposure_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode {
        return this.getToken(IndexDate.DRUG_EXPOSURE_ALIAS, 0)!;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        return this.getRuleContext(0, Drug_exposure_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_event) {
             listener.enterDrug_exposure_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_event) {
             listener.exitDrug_exposure_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event) {
            return visitor.visitDrug_exposure_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Measurement_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public MEASUREMENT_ALIAS(): antlr.TerminalNode {
        return this.getToken(IndexDate.MEASUREMENT_ALIAS, 0)!;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        return this.getRuleContext(0, Measurement_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_event) {
             listener.enterMeasurement_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_event) {
             listener.exitMeasurement_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event) {
            return visitor.visitMeasurement_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Observation_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public OBSERVATION_ALIAS(): antlr.TerminalNode {
        return this.getToken(IndexDate.OBSERVATION_ALIAS, 0)!;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        return this.getRuleContext(0, Observation_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_event) {
             listener.enterObservation_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_event) {
             listener.exitObservation_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_event) {
            return visitor.visitObservation_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Procedure_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROCEDURE_OCCURRENCE_ALIAS, 0)!;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        return this.getRuleContext(0, Procedure_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_event) {
             listener.enterProcedure_occurrence_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_event) {
             listener.exitProcedure_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event) {
            return visitor.visitProcedure_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Visit_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(IndexDate.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(IndexDate.SEMICOLON, 0)!;
    }
    public VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(IndexDate.VISIT_OCCURRENCE_ALIAS, 0)!;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        return this.getRuleContext(0, Visit_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_event;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_event) {
             listener.enterVisit_occurrence_event(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_event) {
             listener.exitVisit_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event) {
            return visitor.visitVisit_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Condition_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Condition_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_event_definition;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_event_definition) {
             listener.enterCondition_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_event_definition) {
             listener.exitCondition_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_definition) {
            return visitor.visitCondition_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Drug_exposure_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DRUG_EXPOSURE, 0)!;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext | null {
        return this.getRuleContext(0, Drug_exposure_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_event_definition;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_event_definition) {
             listener.enterDrug_exposure_event_definition(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_event_definition) {
             listener.exitDrug_exposure_event_definition(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_definition) {
            return visitor.visitDrug_exposure_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Measurement_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT(): antlr.TerminalNode {
        return this.getToken(IndexDate.MEASUREMENT, 0)!;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext | null {
        return this.getRuleContext(0, Measurement_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_event_definition;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_event_definition) {
             listener.enterMeasurement_event_definition(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_event_definition) {
             listener.exitMeasurement_event_definition(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_definition) {
            return visitor.visitMeasurement_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Observation_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION(): antlr.TerminalNode {
        return this.getToken(IndexDate.OBSERVATION, 0)!;
    }
    public observation_event_criteria(): Observation_event_criteriaContext | null {
        return this.getRuleContext(0, Observation_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_event_definition;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_event_definition) {
             listener.enterObservation_event_definition(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_event_definition) {
             listener.exitObservation_event_definition(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_definition) {
            return visitor.visitObservation_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Procedure_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROCEDURE_OCCURRENCE, 0)!;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Procedure_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_event_definition;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_event_definition) {
             listener.enterProcedure_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_event_definition) {
             listener.exitProcedure_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_definition) {
            return visitor.visitProcedure_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Visit_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(IndexDate.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Visit_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_event_definition;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_event_definition) {
             listener.enterVisit_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_event_definition) {
             listener.exitVisit_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_definition) {
            return visitor.visitVisit_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext[];
    public condition_occurrence_event_filter(i: number): Condition_occurrence_event_filterContext | null;
    public condition_occurrence_event_filter(i?: number): Condition_occurrence_event_filterContext[] | Condition_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Condition_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Condition_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_event_criteria) {
             listener.enterCondition_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_event_criteria) {
             listener.exitCondition_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_criteria) {
            return visitor.visitCondition_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filtersContext);
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filtersContext);
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filtersContext);
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_event_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_event_filter) {
             listener.enterCondition_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_event_filter) {
             listener.exitCondition_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_filter) {
            return visitor.visitCondition_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(IndexDate.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_concept_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_concept_filters) {
             listener.enterCondition_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_concept_filters) {
             listener.exitCondition_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filters) {
            return visitor.visitCondition_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(IndexDate.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_concept_group_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_concept_group_filter) {
             listener.enterCondition_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_concept_group_filter) {
             listener.exitCondition_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_group_filter) {
            return visitor.visitCondition_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_concept_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_concept_filter) {
             listener.enterCondition_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_concept_filter) {
             listener.exitCondition_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filter) {
            return visitor.visitCondition_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filters) {
             listener.enterCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filters) {
             listener.exitCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filters) {
            return visitor.visitCondition_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filter) {
             listener.enterCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filter) {
             listener.exitCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filter) {
            return visitor.visitCondition_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(IndexDate.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_related_entity_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_related_entity_filters) {
             listener.enterCondition_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_related_entity_filters) {
             listener.exitCondition_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filters) {
            return visitor.visitCondition_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_related_entity_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_related_entity_filter) {
             listener.enterCondition_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_related_entity_filter) {
             listener.exitCondition_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filter) {
            return visitor.visitCondition_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_sub_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_sub_filter) {
             listener.enterCondition_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_sub_filter) {
             listener.exitCondition_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_sub_filter) {
            return visitor.visitCondition_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE, 0);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_error_sub_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_error_sub_filter) {
             listener.enterCondition_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_error_sub_filter) {
             listener.exitCondition_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_sub_filter) {
            return visitor.visitCondition_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_condition_occurrence_error_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterCondition_occurrence_error_filter) {
             listener.enterCondition_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitCondition_occurrence_error_filter) {
             listener.exitCondition_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_filter) {
            return visitor.visitCondition_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext[];
    public drug_exposure_event_filter(i: number): Drug_exposure_event_filterContext | null;
    public drug_exposure_event_filter(i?: number): Drug_exposure_event_filterContext[] | Drug_exposure_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Drug_exposure_event_filterContext);
        }

        return this.getRuleContext(i, Drug_exposure_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_event_criteria) {
             listener.enterDrug_exposure_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_event_criteria) {
             listener.exitDrug_exposure_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_criteria) {
            return visitor.visitDrug_exposure_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filtersContext);
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_numeric_filtersContext);
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filtersContext);
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_related_entity_filtersContext);
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_error_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_event_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_event_filter) {
             listener.enterDrug_exposure_event_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_event_filter) {
             listener.exitDrug_exposure_event_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_filter) {
            return visitor.visitDrug_exposure_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(IndexDate.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_group_filterContext);
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_concept_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_concept_filters) {
             listener.enterDrug_exposure_concept_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_concept_filters) {
             listener.exitDrug_exposure_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filters) {
            return visitor.visitDrug_exposure_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(IndexDate.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_concept_group_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_concept_group_filter) {
             listener.enterDrug_exposure_concept_group_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_concept_group_filter) {
             listener.exitDrug_exposure_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_group_filter) {
            return visitor.visitDrug_exposure_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_concept_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_concept_filter) {
             listener.enterDrug_exposure_concept_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_concept_filter) {
             listener.exitDrug_exposure_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filter) {
            return visitor.visitDrug_exposure_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(IndexDate.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_float_filterContext);
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_int_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_numeric_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_numeric_filters) {
             listener.enterDrug_exposure_numeric_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_numeric_filters) {
             listener.exitDrug_exposure_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_numeric_filters) {
            return visitor.visitDrug_exposure_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(IndexDate.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_float_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_float_filter) {
             listener.enterDrug_exposure_float_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_float_filter) {
             listener.exitDrug_exposure_float_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_float_filter) {
            return visitor.visitDrug_exposure_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DRUG_EXPOSURE_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_int_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_int_filter) {
             listener.enterDrug_exposure_int_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_int_filter) {
             listener.exitDrug_exposure_int_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_int_filter) {
            return visitor.visitDrug_exposure_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_uniqueness_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_uniqueness_filters) {
             listener.enterDrug_exposure_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_uniqueness_filters) {
             listener.exitDrug_exposure_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filters) {
            return visitor.visitDrug_exposure_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_uniqueness_filter) {
             listener.enterDrug_exposure_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_uniqueness_filter) {
             listener.exitDrug_exposure_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filter) {
            return visitor.visitDrug_exposure_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(IndexDate.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        return this.getRuleContext(0, Drug_exposure_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_related_entity_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_related_entity_filters) {
             listener.enterDrug_exposure_related_entity_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_related_entity_filters) {
             listener.exitDrug_exposure_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filters) {
            return visitor.visitDrug_exposure_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_related_entity_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_related_entity_filter) {
             listener.enterDrug_exposure_related_entity_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_related_entity_filter) {
             listener.exitDrug_exposure_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filter) {
            return visitor.visitDrug_exposure_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.DRUG_EXPOSURE_INT_ATTRIBUTE, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_drug_exposure_error_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterDrug_exposure_error_filter) {
             listener.enterDrug_exposure_error_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitDrug_exposure_error_filter) {
             listener.exitDrug_exposure_error_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_error_filter) {
            return visitor.visitDrug_exposure_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_event_filter(): Measurement_event_filterContext[];
    public measurement_event_filter(i: number): Measurement_event_filterContext | null;
    public measurement_event_filter(i?: number): Measurement_event_filterContext[] | Measurement_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Measurement_event_filterContext);
        }

        return this.getRuleContext(i, Measurement_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_event_criteria) {
             listener.enterMeasurement_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_event_criteria) {
             listener.exitMeasurement_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_criteria) {
            return visitor.visitMeasurement_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext | null {
        return this.getRuleContext(0, Measurement_concept_filtersContext);
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext | null {
        return this.getRuleContext(0, Measurement_numeric_filtersContext);
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Measurement_uniqueness_filtersContext);
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext | null {
        return this.getRuleContext(0, Measurement_related_entity_filtersContext);
    }
    public measurement_error_filter(): Measurement_error_filterContext | null {
        return this.getRuleContext(0, Measurement_error_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_event_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_event_filter) {
             listener.enterMeasurement_event_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_event_filter) {
             listener.exitMeasurement_event_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_filter) {
            return visitor.visitMeasurement_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(IndexDate.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_group_filterContext);
    }
    public measurement_concept_filter(): Measurement_concept_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_concept_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_concept_filters) {
             listener.enterMeasurement_concept_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_concept_filters) {
             listener.exitMeasurement_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filters) {
            return visitor.visitMeasurement_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(IndexDate.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_concept_group_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_concept_group_filter) {
             listener.enterMeasurement_concept_group_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_concept_group_filter) {
             listener.exitMeasurement_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_group_filter) {
            return visitor.visitMeasurement_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONCEPT, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_concept_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_concept_filter) {
             listener.enterMeasurement_concept_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_concept_filter) {
             listener.exitMeasurement_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filter) {
            return visitor.visitMeasurement_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(IndexDate.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        return this.getRuleContext(0, Measurement_float_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_numeric_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_numeric_filters) {
             listener.enterMeasurement_numeric_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_numeric_filters) {
             listener.exitMeasurement_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_numeric_filters) {
            return visitor.visitMeasurement_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_float_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_float_filter) {
             listener.enterMeasurement_float_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_float_filter) {
             listener.exitMeasurement_float_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_float_filter) {
            return visitor.visitMeasurement_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        return this.getRuleContext(0, Measurement_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_uniqueness_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_uniqueness_filters) {
             listener.enterMeasurement_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_uniqueness_filters) {
             listener.exitMeasurement_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filters) {
            return visitor.visitMeasurement_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.MEASUREMENT_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_uniqueness_filter) {
             listener.enterMeasurement_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_uniqueness_filter) {
             listener.exitMeasurement_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filter) {
            return visitor.visitMeasurement_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(IndexDate.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        return this.getRuleContext(0, Measurement_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_related_entity_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_related_entity_filters) {
             listener.enterMeasurement_related_entity_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_related_entity_filters) {
             listener.exitMeasurement_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filters) {
            return visitor.visitMeasurement_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_related_entity_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_related_entity_filter) {
             listener.enterMeasurement_related_entity_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_related_entity_filter) {
             listener.exitMeasurement_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filter) {
            return visitor.visitMeasurement_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NF, 0);
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_measurement_error_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterMeasurement_error_filter) {
             listener.enterMeasurement_error_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitMeasurement_error_filter) {
             listener.exitMeasurement_error_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_error_filter) {
            return visitor.visitMeasurement_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_event_filter(): Observation_event_filterContext[];
    public observation_event_filter(i: number): Observation_event_filterContext | null;
    public observation_event_filter(i?: number): Observation_event_filterContext[] | Observation_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Observation_event_filterContext);
        }

        return this.getRuleContext(i, Observation_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_event_criteria) {
             listener.enterObservation_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_event_criteria) {
             listener.exitObservation_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_criteria) {
            return visitor.visitObservation_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_concept_filters(): Observation_concept_filtersContext | null {
        return this.getRuleContext(0, Observation_concept_filtersContext);
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext | null {
        return this.getRuleContext(0, Observation_numeric_filtersContext);
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Observation_uniqueness_filtersContext);
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext | null {
        return this.getRuleContext(0, Observation_related_entity_filtersContext);
    }
    public observation_error_filter(): Observation_error_filterContext | null {
        return this.getRuleContext(0, Observation_error_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_event_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_event_filter) {
             listener.enterObservation_event_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_event_filter) {
             listener.exitObservation_event_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_filter) {
            return visitor.visitObservation_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(IndexDate.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext | null {
        return this.getRuleContext(0, Observation_concept_group_filterContext);
    }
    public observation_concept_filter(): Observation_concept_filterContext | null {
        return this.getRuleContext(0, Observation_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_concept_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_concept_filters) {
             listener.enterObservation_concept_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_concept_filters) {
             listener.exitObservation_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filters) {
            return visitor.visitObservation_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(IndexDate.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_concept_group_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_concept_group_filter) {
             listener.enterObservation_concept_group_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_concept_group_filter) {
             listener.exitObservation_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_group_filter) {
            return visitor.visitObservation_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONCEPT, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_concept_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_concept_filter) {
             listener.enterObservation_concept_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_concept_filter) {
             listener.exitObservation_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filter) {
            return visitor.visitObservation_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(IndexDate.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public observation_float_filter(): Observation_float_filterContext | null {
        return this.getRuleContext(0, Observation_float_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_numeric_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_numeric_filters) {
             listener.enterObservation_numeric_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_numeric_filters) {
             listener.exitObservation_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_numeric_filters) {
            return visitor.visitObservation_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_float_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_float_filter) {
             listener.enterObservation_float_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_float_filter) {
             listener.exitObservation_float_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_float_filter) {
            return visitor.visitObservation_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        return this.getRuleContext(0, Observation_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_uniqueness_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_uniqueness_filters) {
             listener.enterObservation_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_uniqueness_filters) {
             listener.exitObservation_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filters) {
            return visitor.visitObservation_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.OBSERVATION_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_uniqueness_filter) {
             listener.enterObservation_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_uniqueness_filter) {
             listener.exitObservation_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filter) {
            return visitor.visitObservation_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(IndexDate.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        return this.getRuleContext(0, Observation_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_related_entity_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_related_entity_filters) {
             listener.enterObservation_related_entity_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_related_entity_filters) {
             listener.exitObservation_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filters) {
            return visitor.visitObservation_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_related_entity_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_related_entity_filter) {
             listener.enterObservation_related_entity_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_related_entity_filter) {
             listener.exitObservation_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filter) {
            return visitor.visitObservation_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NF, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_observation_error_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterObservation_error_filter) {
             listener.enterObservation_error_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitObservation_error_filter) {
             listener.exitObservation_error_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitObservation_error_filter) {
            return visitor.visitObservation_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext[];
    public procedure_occurrence_event_filter(i: number): Procedure_occurrence_event_filterContext | null;
    public procedure_occurrence_event_filter(i?: number): Procedure_occurrence_event_filterContext[] | Procedure_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Procedure_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Procedure_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_event_criteria) {
             listener.enterProcedure_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_event_criteria) {
             listener.exitProcedure_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_criteria) {
            return visitor.visitProcedure_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filtersContext);
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_numeric_filtersContext);
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filtersContext);
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filtersContext);
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_event_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_event_filter) {
             listener.enterProcedure_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_event_filter) {
             listener.exitProcedure_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_filter) {
            return visitor.visitProcedure_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(IndexDate.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_group_filterContext);
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_concept_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_concept_filters) {
             listener.enterProcedure_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_concept_filters) {
             listener.exitProcedure_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filters) {
            return visitor.visitProcedure_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(IndexDate.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_concept_group_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_concept_group_filter) {
             listener.enterProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_concept_group_filter) {
             listener.exitProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_group_filter) {
            return visitor.visitProcedure_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_concept_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_concept_filter) {
             listener.enterProcedure_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_concept_filter) {
             listener.exitProcedure_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filter) {
            return visitor.visitProcedure_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(IndexDate.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_int_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_numeric_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_numeric_filters) {
             listener.enterProcedure_occurrence_numeric_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_numeric_filters) {
             listener.exitProcedure_occurrence_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_numeric_filters) {
            return visitor.visitProcedure_occurrence_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(IndexDate.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_int_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_int_filter) {
             listener.enterProcedure_occurrence_int_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_int_filter) {
             listener.exitProcedure_occurrence_int_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_int_filter) {
            return visitor.visitProcedure_occurrence_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filters) {
             listener.enterProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filters) {
             listener.exitProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filters) {
            return visitor.visitProcedure_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filter) {
             listener.enterProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filter) {
             listener.exitProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filter) {
            return visitor.visitProcedure_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(IndexDate.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_related_entity_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filters) {
             listener.enterProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filters) {
             listener.exitProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filters) {
            return visitor.visitProcedure_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_related_entity_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filter) {
             listener.enterProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filter) {
             listener.exitProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filter) {
            return visitor.visitProcedure_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_procedure_occurrence_error_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProcedure_occurrence_error_filter) {
             listener.enterProcedure_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProcedure_occurrence_error_filter) {
             listener.exitProcedure_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_error_filter) {
            return visitor.visitProcedure_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(IndexDate.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_provider_concept_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProvider_concept_filters) {
             listener.enterProvider_concept_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProvider_concept_filters) {
             listener.exitProvider_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filters) {
            return visitor.visitProvider_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(IndexDate.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_provider_concept_group_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProvider_concept_group_filter) {
             listener.enterProvider_concept_group_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProvider_concept_group_filter) {
             listener.exitProvider_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_group_filter) {
            return visitor.visitProvider_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_provider_concept_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProvider_concept_filter) {
             listener.enterProvider_concept_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProvider_concept_filter) {
             listener.exitProvider_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filter) {
            return visitor.visitProvider_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode {
        return this.getToken(IndexDate.PROVIDER, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_provider_sub_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProvider_sub_filter) {
             listener.enterProvider_sub_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProvider_sub_filter) {
             listener.exitProvider_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProvider_sub_filter) {
            return visitor.visitProvider_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.PROVIDER, 0);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.PROVIDER_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_provider_error_sub_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterProvider_error_sub_filter) {
             listener.enterProvider_error_sub_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitProvider_error_sub_filter) {
             listener.exitProvider_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitProvider_error_sub_filter) {
            return visitor.visitProvider_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext[];
    public visit_occurrence_event_filter(i: number): Visit_occurrence_event_filterContext | null;
    public visit_occurrence_event_filter(i?: number): Visit_occurrence_event_filterContext[] | Visit_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Visit_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Visit_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_event_criteria;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_event_criteria) {
             listener.enterVisit_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_event_criteria) {
             listener.exitVisit_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_criteria) {
            return visitor.visitVisit_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filtersContext);
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filtersContext);
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filtersContext);
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_event_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_event_filter) {
             listener.enterVisit_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_event_filter) {
             listener.exitVisit_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_filter) {
            return visitor.visitVisit_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(IndexDate.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_concept_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_concept_filters) {
             listener.enterVisit_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_concept_filters) {
             listener.exitVisit_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filters) {
            return visitor.visitVisit_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(IndexDate.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_concept_group_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_concept_group_filter) {
             listener.enterVisit_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_concept_group_filter) {
             listener.exitVisit_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_group_filter) {
            return visitor.visitVisit_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(IndexDate.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_concept_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_concept_filter) {
             listener.enterVisit_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_concept_filter) {
             listener.exitVisit_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filter) {
            return visitor.visitVisit_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(IndexDate.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filters) {
             listener.enterVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filters) {
             listener.exitVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filters) {
            return visitor.visitVisit_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(IndexDate.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filter) {
             listener.enterVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filter) {
             listener.exitVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filter) {
            return visitor.visitVisit_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(IndexDate.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_related_entity_filters;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_related_entity_filters) {
             listener.enterVisit_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_related_entity_filters) {
             listener.exitVisit_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filters) {
            return visitor.visitVisit_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_related_entity_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_related_entity_filter) {
             listener.enterVisit_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_related_entity_filter) {
             listener.exitVisit_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filter) {
            return visitor.visitVisit_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(IndexDate.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_sub_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_sub_filter) {
             listener.enterVisit_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_sub_filter) {
             listener.exitVisit_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_sub_filter) {
            return visitor.visitVisit_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.VISIT_OCCURRENCE, 0);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_error_sub_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_error_sub_filter) {
             listener.enterVisit_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_error_sub_filter) {
             listener.exitVisit_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_sub_filter) {
            return visitor.visitVisit_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(IndexDate.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_visit_occurrence_error_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterVisit_occurrence_error_filter) {
             listener.enterVisit_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitVisit_occurrence_error_filter) {
             listener.exitVisit_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_filter) {
            return visitor.visitVisit_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Comparison_opContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.EQ, 0);
    }
    public LT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.LT, 0);
    }
    public GT(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.GT, 0);
    }
    public LTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.LTE, 0);
    }
    public GTE(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.GTE, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_comparison_op;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterComparison_op) {
             listener.enterComparison_op(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitComparison_op) {
             listener.exitComparison_op(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitComparison_op) {
            return visitor.visitComparison_op(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(IndexDate.MINIMUM_BETWEEN, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(IndexDate.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_simple_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSimple_uniqueness_filter) {
             listener.enterSimple_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSimple_uniqueness_filter) {
             listener.exitSimple_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter) {
            return visitor.visitSimple_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Fixed_window_uniqueness_filterContext);
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_simple_uniqueness_filter_window;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSimple_uniqueness_filter_window) {
             listener.enterSimple_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSimple_uniqueness_filter_window) {
             listener.exitSimple_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter_window) {
            return visitor.visitSimple_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(IndexDate.FIXED_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(IndexDate.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterFixed_window_uniqueness_filter) {
             listener.enterFixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitFixed_window_uniqueness_filter) {
             listener.exitFixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitFixed_window_uniqueness_filter) {
            return visitor.visitFixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(IndexDate.ROLLING_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(IndexDate.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterRolling_window_uniqueness_filter) {
             listener.enterRolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitRolling_window_uniqueness_filter) {
             listener.exitRolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitRolling_window_uniqueness_filter) {
            return visitor.visitRolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_floatContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(IndexDate.PERIOD, 0);
    }
    public INT(): antlr.TerminalNode[];
    public INT(i: number): antlr.TerminalNode | null;
    public INT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.INT);
    	} else {
    		return this.getToken(IndexDate.INT, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_simple_event_float;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSimple_event_float) {
             listener.enterSimple_event_float(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSimple_event_float) {
             listener.exitSimple_event_float(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_float) {
            return visitor.visitSimple_event_float(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(IndexDate.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_simple_event_int;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterSimple_event_int) {
             listener.enterSimple_event_int(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitSimple_event_int) {
             listener.exitSimple_event_int(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_int) {
            return visitor.visitSimple_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Concept_group_selectionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT_GROUP(): antlr.TerminalNode[];
    public CONCEPT_GROUP(i: number): antlr.TerminalNode | null;
    public CONCEPT_GROUP(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.CONCEPT_GROUP);
    	} else {
    		return this.getToken(IndexDate.CONCEPT_GROUP, i);
    	}
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(IndexDate.COMMA);
    	} else {
    		return this.getToken(IndexDate.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return IndexDate.RULE_concept_group_selection;
    }
    public override enterRule(listener: IndexDateListener): void {
        if(listener.enterConcept_group_selection) {
             listener.enterConcept_group_selection(this);
        }
    }
    public override exitRule(listener: IndexDateListener): void {
        if(listener.exitConcept_group_selection) {
             listener.exitConcept_group_selection(this);
        }
    }
    public override accept<Result>(visitor: IndexDateVisitor<Result>): Result | null {
        if (visitor.visitConcept_group_selection) {
            return visitor.visitConcept_group_selection(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
